import { Injectable } from '@angular/core';
import { PendingPhoto } from '../models/photo/pending-photo';
import { LogService } from '../baseServices/logging/log.service';
import { RepositoryService } from '../baseServices/repository.service';
import { SyncActionService } from '../baseServices/sync-action.service';
import { SyncService, SyncType } from '../baseServices/sync.service';
import { ActivityType } from '../constant/activity-constants';
import { ActivityLogStatusHierarchy } from '../constant/activity-log-constants';
import { SyncActionTypeId } from '../constant/sync-action-constants';
import { TimeRecordActivity, TimeRecordConstants } from '../constant/time-record-constants';
import { UpdateNotableActivityDataDto } from '../dtos/activity-service-dtos';
import { UpdateOdometerReadingDataDto } from '../dtos/odometer-reading-service-dtos';
import { ApproveTimeAuxillaryDto, ApproveTimePayloadDto, CancelMealBreakAuxillaryDto, CancelMealBreakPayloadDto, CancelRestBreakAuxillaryDto, CancelRestBreakPayloadDto, ClockInAuxillaryDto, ClockInPayloadDto, ClockOutAuxillaryDto, ClockOutPayloadDto, CreateClosedMealBreakTimeAuxillaryDto, CreateClosedMealBreakTimePayloadDto, CreateClosedWorkingTimeAuxillaryDto, CreateClosedWorkingTimePayloadDto, CreateFlexDocActivityAuxillaryDto, CreateFlexDocActivityPayloadDto, CreateNotableActivityAuxillaryDto, CreateNotableActivityPayloadDto, CreateOdometerReadingAuxillaryDto, CreateOdometerReadingPayloadDto, DeleteNotableActivityAuxillaryDto, DeleteNotableActivityPayloadDto, DeleteOdometerReadingAuxillaryDto, DeleteOdometerReadingPayloadDto, DeleteTimeAuxillaryDto, DeleteTimePayloadDto, EndMealBreakAuxillaryDto, EndMealBreakPayloadDto, ReturnTimeAuxillaryDto, ReturnTimePayloadDto, StartMealBreakAuxillaryDto, StartMealBreakPayloadDto, StartNewAssignmentAuxillaryDto, StartNewAssignmentPayloadDto, SubmitTimeAuxillaryDto, SubmitTimePayloadDto, UpdateAssignmentAuxillaryDto, UpdateAssignmentPayloadDto, UpdateNotableActivityAuxillaryDto, UpdateNotableActivityPayloadDto, UpdateOdometerReadingAuxillaryDto, UpdateOdometerReadingPayloadDto, UpdateTimeClocksAuxillaryDto, UpdateTimeClocksPayloadDto, VerifyTimeAuxillaryDto, VerifyTimePayloadDto } from '../dtos/sync-action-service-dtos';
import {
  ActivityLogWithChildrenDto,
  ApproveTimeDataDto,
  ApproveTimeSyncActionDataDto,
  CancelMealBreakDataDto,
  CancelMealBreakSyncActionDataDto,
  CancelRestBreakDataDto,
  CancelRestBreakLocalCopyDto,
  CancelRestBreakSyncActionDataDto,
  ClockInDataDto,
  ClockInResultDto,
  ClockInSyncActionDataDto,
  ClockOutDataDto,
  ClockOutSyncActionDataDto,
  CloseMealBreakTimeDataDto,
  CloseOdometerReadingIfNeededDataDto,
  CloseWorkingTimeDataDto,
  CloseWorkingTimeResultDto,
  CreateClosedMealBreakTimeDataDto,
  CreateClosedMealBreakTimeResultDto,
  CreateClosedMealBreakTimeSyncActionDataDto,
  CreateClosedTimeDataDto,
  CreateClosedTimeResultDto,
  CreateClosedWorkingTimeDataDto,
  CreateClosedWorkingTimeResultDto,
  CreateClosedWorkingTimeSyncActionDataDto,
  CreateFlexActivitySyncActionDataDto,
  CreateFlexDocActivityTimeDataDto,
  CreateFlexDocActivityTimeResultDto,
  CreateNotableActivitySyncActionDataDto,
  CreateNotableActivityTimeDataDto,
  CreateOdometerReadingSyncActionDataDto,
  CreateOdometerReadingTimeDataDto,
  CreateOpenOdometerReadingIfNeededDataDto,
  CreateOpenTimeDataDto,
  CreateOpenTimeResultDto,
  DeleteNotableActivityDataDto,
  DeleteNotableActivitySyncActionDataDto,
  DeleteOdometerReadingDataDto,
  DeleteOdometerReadingSyncActionDataDto,
  DeleteTimeDataDto,
  DeleteTimeSyncActionDataDto,
  EndMealBreakDataDto,
  EndMealBreakResultDto,
  EndMealBreakSyncActionDataDto,
  GetOrphanedNotableActivitiesDataDto,
  ReturnTimeDataDto,
  ReturnTimeSyncActionDataDto,
  StartMealBreakDataDto,
  StartMealBreakResultDto,
  StartMealBreakSyncActionDataDto,
  StartNewAssignmentDataDto,
  StartNewAssignmentResultDto,
  StartNewAssignmentSyncActionDataDto,
  StartRestBreakDataDto,
  SubmitTimeDataDto,
  SubmitTimeSyncActionDataDto,
  TrackMileageDataDto,
  UpdateAssignmentDataDto,
  UpdateAssignmentResultDto,
  UpdateAssignmentSyncActionDataDto,
  UpdateNotableActivitySyncActionDataDto,
  UpdateOdometerReadingSyncActionDataDto,
  UpdateTimeClocksDataDto,
  UpdateTimeClocksSyncActionDataDto,
  VerifyTimeDataDto,
  VerifyTimeSyncActionDataDto,
} from '../dtos/time-service-dtos';
import { Activity } from '../entities/Activity';
import { ActivityLog } from '../entities/ActivityLog';
import { OdometerReading } from '../entities/OdometerReading';
import { OdometerPhotoType, OdometerReadingMedia, UploadStatus } from '../entities/OdometerReadingMedia';
import { StoreName } from '../entities/StoreName';
import { TimeRecord } from '../entities/timeRecord';
import { DataChangeEmitWho } from '../models/data-change-emit/data-change-emit-payload';
import { DbTransaction } from '../models/db/db-transaction';
import { DateTimeHelper, DateTimeType } from '../utils/date-time-helper';
import { Check, EntityHelper } from '../utils/entity-helper';
import { ActionValidationException, ValidationException } from '../utils/exceptions';
import { ActivityService } from './activity.service';
import { ActivityLogService } from './activityLog.service';
import { OdometerReadingService } from './odometer-reading.service';
import { OdometerReadingMediaService } from './odometer-reading-media.service';
import { ProjectService } from './project.service';
import { TimeRecordService } from './timeRecord.service';
import { UserService } from './user.service';
import { CreateClosedRestBreakTimeAuxillaryDto } from '../dtos/sync-action-service-dtos/auxillary-dtos/create-closed-rest-break-time-auxillary-data-dto';
import { CreateClosedRestBreakTimePayloadDto } from '../dtos/sync-action-service-dtos/payload-dtos/create-closed-rest-break-time-payload-dto';
import { CreateClosedRestBreakTimeDataDto } from '../dtos/time-service-dtos/data-dtos/create-closed-rest-break-time-data-dto';
import { CreateClosedRestBreakTimeSyncActionDataDto } from '../dtos/time-service-dtos/data-dtos/sync-action-data-dtos/create-closed-rest-break-time-sync-action-data-dto';
import { StartRestBreakSyncActionDataDto } from '../dtos/time-service-dtos/data-dtos/sync-action-data-dtos/start-rest-break-sync-action-data-dto';
import { CreateClosedRestBreakTimeResultDto } from '../dtos/time-service-dtos/result-dtos/create-closed-rest-break-time-result-dto';
import { StartRestBreakResultDto } from '../dtos/time-service-dtos/result-dtos/start-rest-break-result-dto';
import { FIPSStateService } from './fips-state.service';

@Injectable({
  providedIn: 'root',
})
export class TimeService {

  constructor(
    private timeRecordService: TimeRecordService,
    private activityLogService: ActivityLogService,
    private activityService: ActivityService,
    private userService: UserService,
    private projectService: ProjectService,
    private odometerReadingService: OdometerReadingService,
    private odometerReadingMediaService: OdometerReadingMediaService,
    private fipsStateService: FIPSStateService,
    private repositoryService: RepositoryService,
    private syncActionService: SyncActionService,
    private syncService: SyncService,
    private logService: LogService
  ) { }

  // #region Utility

  private async startTransactionIfNeeded(existingTransaction?: DbTransaction, additionalStoreNames?: StoreName[], mode?: 'readwrite' | 'readonly'): Promise<DbTransaction> {
    if (existingTransaction) {
      return existingTransaction;
    } else {
      const storeNames = [
        StoreName.Activity,
        StoreName.ActivityLog,
        StoreName.TimeRecord,
        StoreName.StatusLookup,
        StoreName.TimeRecordStatus,
        StoreName.SyncActionQueue,
        StoreName.EntityType,
        StoreName.OdometerReading,
        StoreName.OdometerReadingMedia,
        StoreName.Project,
        ...(additionalStoreNames || []),
      ];
      return await this.repositoryService.startTransaction(Array.from(new Set(storeNames)), mode ?? 'readwrite');
    }
  }

  // #endregion

  // #region High-level Get

  async getTimeRecordsForActivityLog(activityLog: ActivityLog, existingTransaction?: DbTransaction): Promise<TimeRecord[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.TimeRecord], 'readonly');
    const promises: Promise<TimeRecord[]>[] = [];

    if (activityLog.Id) {
      promises.push(this.timeRecordService.getTimeRecordsByActivityLogId(activityLog.Id, transaction));
    }

    if (activityLog.RecordId) {
      promises.push(this.timeRecordService.getTimeRecordsByActivityLogRecordId(activityLog.RecordId, transaction));
    }

    const results = await Promise.all(promises);
    const timeRecords = results.reduce((acc, val) => acc.concat(val), []);

    const uniqueTimeRecords = this.timeRecordService.filterForUniqueTimeRecords(timeRecords);
    return uniqueTimeRecords;
  }

  async getActivitiesForActivityLog(activityLog: ActivityLog, existingTransaction?: DbTransaction): Promise<Activity[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const promises: Promise<Activity[]>[] = [];

    if (activityLog.Id) {
      promises.push(this.activityService.getActivitiesByActivityLogId(activityLog.Id, transaction));
    }

    if (activityLog.RecordId) {
      promises.push(this.activityService.getActivitiesByActivityLogRecordId(activityLog.RecordId, transaction));
    }

    const results = await Promise.all(promises);
    const activities = results.reduce((acc, val) => acc.concat(val), []);

    return this.activityService.filterForUniqueActivities(activities);
  }

  async getOdometerReadingsForActivityLog(activityLog: ActivityLog, existingTransaction?: DbTransaction): Promise<OdometerReading[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const promises: Promise<OdometerReading[]>[] = [];

    if (activityLog.Id) {
      promises.push(this.odometerReadingService.getOdometerReadingsByActivityLogId(activityLog.Id, transaction));
    }

    if (activityLog.RecordId) {
      promises.push(this.odometerReadingService.getOdometerReadingsByActivityLogRecordId(activityLog.RecordId, transaction));
    }

    const results = await Promise.all(promises);
    const odometerReadings = results.reduce((acc, val) => acc.concat(val), []);

    return this.odometerReadingService.filterForUniqueOdometerReadings(odometerReadings);
  }

  async getActivityLogForOdometerReading(odometerReading: OdometerReading, existingTransaction?: DbTransaction): Promise<ActivityLog> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.ActivityLog], 'readonly');

    if (odometerReading.ActivityLogId) {
      return this.activityLogService.getActivityLogByOnlineId(odometerReading.ActivityLogId, transaction);
    } else {
      return this.activityLogService.getActivityLogByRecordId(odometerReading.ActivityLogRecordId, transaction);
    }
  }

  async getActivitiesForTimeRecord(timeRecord: TimeRecord, existingTransaction?: DbTransaction): Promise<Activity[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const promises: Promise<Activity[]>[] = [];

    if (timeRecord.Id) {
      promises.push(this.activityService.getActivitiesByReferenceId(timeRecord.Id, transaction));
    }

    if (timeRecord.RecordId) {
      promises.push(this.activityService.getActivitiesByReferenceRecordId(timeRecord.RecordId, transaction));
    }

    const results = await Promise.all(promises);
    const activities = results.reduce((acc, val) => acc.concat(val), []);

    return this.activityService.filterForUniqueActivities(activities);
  }

  async getNotableActivitiesForTimeRecord(timeRecord: TimeRecord, existingTransaction?: DbTransaction): Promise<Activity[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const allActivities = await this.getActivitiesForTimeRecord(timeRecord, transaction);
    const notableActivities = allActivities.filter(activity => this.activityService.checkIsNotableActivity(activity));
    return notableActivities;
  }

  async getTimeRecordsForActivityLogs(activityLogs: ActivityLog[], existingTransaction?: DbTransaction): Promise<TimeRecord[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.TimeRecord], 'readonly');
    const promises = activityLogs.map(activityLog => this.getTimeRecordsForActivityLog(activityLog, transaction));
    const results = await Promise.all(promises);
    const timeRecords = results.reduce((acc, val) => acc.concat(val), []);
    return timeRecords;
  }

  async getActivitiesForActivityLogs(activityLogs: ActivityLog[], existingTransaction?: DbTransaction): Promise<Activity[]> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const promises = activityLogs.map(activityLog => this.getActivitiesForActivityLog(activityLog, transaction));
    const results = await Promise.all(promises);
    const activities = results.reduce((acc, val) => acc.concat(val), []);
    return activities;
  }

  async getActivityLogForTimeRecord(timeRecord: TimeRecord, existingTransaction?: DbTransaction): Promise<ActivityLog> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.ActivityLog], 'readonly');

    if (timeRecord.ActivityLogId) {
      return this.activityLogService.getActivityLogByOnlineId(timeRecord.ActivityLogId, transaction);
    } else {
      return this.activityLogService.getActivityLogByRecordId(timeRecord.ActivityLogRecordId, transaction);
    }
  }

  async getOrphanedNotableActivities(data: GetOrphanedNotableActivitiesDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.Activity], 'readonly');
    const notableActivities = await this.getNotableActivitiesForTimeRecord(data.TimeRecordToEdit, transaction);

    const orphanedActivities = notableActivities.filter(activity => {
      if (data.ClockOut) {
        return (
          !DateTimeHelper.checkTimeIsBetween(activity.UserSpecifiedDate, activity.TimeZoneId, data.ClockIn, data.ClockInTimeZoneId, data.ClockOut, data.ClockOutTimeZoneId, true) ||
          DateTimeHelper.checkTimeIsEqual(activity.UserSpecifiedDate, activity.TimeZoneId, data.ClockOut, data.ClockOutTimeZoneId)
        );
      } else {
        return !DateTimeHelper.checkTimeIsAfter(activity.UserSpecifiedDate, activity.TimeZoneId, data.ClockIn, data.ClockInTimeZoneId, true);
      }
    });

    return orphanedActivities;
  }

  // #endregion
  // #region High-level Create

  async clockIn(who: DataChangeEmitWho, data: ClockInDataDto, existingTransaction?: DbTransaction): Promise<ClockInResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let createOpenTimeResult: CreateOpenTimeResultDto;
    let odometerReadingRecordId: number;
    let odometerReadingMediaRecordId: number;

    try {
      await this.validateClockIn(data, transaction);

      const createOpenTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Working,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createOpenTimeResult = await this.createOpenTime(who, createOpenTimeData, transaction);

      const createOpenOdometerReadingIfNeededData = {
        ActivityLogRecordId: createOpenTimeResult.ActivityLogRecordId,
        UserId: data.UserId,
        Date: data.ClockIn,
        CurrentProjectId: null,
        NextProjectId: data.ProjectId,
        TrackMileage: data.TrackMileage,
        OdometerValue: data.OdometerValue,
        OdometerPhoto: data.OdometerPhoto,
      };
      odometerReadingRecordId = await this.createOpenOdometerReadingIfNeeded(who, createOpenOdometerReadingIfNeededData, transaction);

      // Create OdometerReadingMedia if photo was provided
      if(odometerReadingRecordId && data.OdometerPhoto) {
        odometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(odometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.Start, transaction);
      }
      const createSyncActionData = {
        ...data,
        ...createOpenTimeResult,
        OdometerReadingRecordId: odometerReadingRecordId,
        OdometerReadingMediaRecordId: odometerReadingMediaRecordId,
      };
      await this.createClockInSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: ClockInResultDto = {
      ...createOpenTimeResult,
      ClockInActivityRecordId: createOpenTimeResult.ClockStartActivityRecordId,
      OdometerReadingRecordId: odometerReadingRecordId,
    };
    this.logService.event('Time.ClockInCompleted', { timeRecordId: createOpenTimeResult.TimeRecordRecordId, activityLogId: createOpenTimeResult.ActivityLogRecordId, odometerReadingRecordId });
    return result;
  }

  async startRestBreak(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: StartRestBreakDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<StartRestBreakResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.FIPSState]);
    let closeWorkingTimeResult: CloseWorkingTimeResultDto;
    let createClosedTimeResult: CreateClosedTimeResultDto;
    let clockInResult: CreateOpenTimeResultDto;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      const activityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateStartRestBreak(data, existingTimeRecord, transaction);

      const closeWorkingTimeData = {
        ...data,
        UserId: existingTimeRecord.EmployeeId,
        ActivityLogRecordId: activityLog.RecordId,
      };
      closeWorkingTimeResult = await this.closeWorkingTime(who, openTimeRecordRecordId, closeWorkingTimeData, skipLocalCopyValidation, localCopy, transaction);

      const restBreakEnd = DateTimeHelper.addTime(data.ClockIn, TimeRecordConstants.REST_BREAK_DURATION_MINUTES, 'minutes');
      const createClosedTimeData = {
        ...data,
        ClockOut: restBreakEnd,
        ClockOutTimeZoneId: data.ClockInTimeZoneId,
        CapturedClockOut: data.CapturedClockIn,
        CapturedClockOutTimeZoneId: data.CapturedClockInTimeZoneId,
        TimeRecordActivity: TimeRecordActivity.Rest,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };

      createClosedTimeResult = await this.createClosedTime(who, createClosedTimeData, transaction);

      const clockInData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Working,
        ClockIn: restBreakEnd,
        ClockInTimeZoneId: data.ClockInTimeZoneId,
        CapturedClockIn: data.CapturedClockIn,
        CapturedClockInTimeZoneId: data.CapturedClockInTimeZoneId,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };

      clockInResult = await this.createOpenTime(who, clockInData, transaction);

      const createSyncActionData = {
        ...data,
        ActivityLogIsNew: createClosedTimeResult.ActivityLogIsNew,
        ActivityLogRecordId: createClosedTimeResult.ActivityLogRecordId,
        ClockOutActivityRecordId: closeWorkingTimeResult.ClockOutActivityRecordId,
        BreakTimeRecordRecordId: createClosedTimeResult.TimeRecordRecordId,
        BreakActivityRecordId: createClosedTimeResult.ClockStartActivityRecordId,
        WorkingTimeRecordRecordId: clockInResult.TimeRecordRecordId,
        ClockStartActivityRecordId: clockInResult.ClockStartActivityRecordId,
        ExistingTimeRecord: existingTimeRecord,
      }
      await this.createStartRestBreakSyncAction(createSyncActionData, transaction);

      await this.validateNoOrphanedNotableActivities(data.UserId, data.ClockIn, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: StartRestBreakResultDto = {
      CloseWorkingTimeRecordResult: closeWorkingTimeResult,
      CreateRestBreakTimeRecordResult: createClosedTimeResult,
      CreateOpenWorkingTimeRecordResult: clockInResult,
    };
    this.logService.event('Time.StartRestBreakCompleted', { newBreakTimeRecordId: createClosedTimeResult.TimeRecordRecordId, closedWorkingTimeRecordId: closeWorkingTimeResult?.ClockOutActivityRecordId });
    return result;
  }

  async startMealBreak(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: StartMealBreakDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<StartMealBreakResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let closeWorkingTimeResult: CloseWorkingTimeResultDto;
    let createOpenTimeResult: CreateOpenTimeResultDto;
    let odometerReadingRecordId: number;
    let closedOdometerReadingRecordId: number | null;
    let startOdometerReadingMediaRecordId: number | null;
    let endOdometerReadingMediaRecordId: number | null;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      const existingOdometerReading = await this.odometerReadingService.getOpenOdometerReading(data.UserId, existingTimeRecord.ClockIn, transaction);
      const activityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateStartMealBreak(data, existingTimeRecord, transaction);

      const closeWorkingTimeData = {
        ...data,
        UserId: existingTimeRecord.EmployeeId,
        ActivityLogRecordId: activityLog.RecordId,
      };
      closeWorkingTimeResult = await this.closeWorkingTime(who, openTimeRecordRecordId, closeWorkingTimeData, skipLocalCopyValidation, localCopy, transaction);

      const closeOdometerReadingIfNeededData = {
        UserId: existingTimeRecord.EmployeeId,
        Date: existingTimeRecord.ClockIn,
        OdometerValue: data.OdometerValue,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        OdometerPhoto: data.OdometerPhoto,
      };
      closedOdometerReadingRecordId = await this.closeOdometerReadingIfNeeded(who, closeOdometerReadingIfNeededData, true, null, transaction); // Note: local copy check not yet implemented for odometer readings

      // Create OdometerReadingMedia for the existing odometer reading that was closed if photo was provided
      if (closedOdometerReadingRecordId && data.OdometerPhoto) {
        endOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(closedOdometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.End, transaction);
      }

      const createOpenTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Meal,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createOpenTimeResult = await this.createOpenTime(who, createOpenTimeData, transaction);

      const createOpenOdometerReadingIfNeededData = {
        ActivityLogRecordId: createOpenTimeResult.ActivityLogRecordId,
        UserId: data.UserId,
        Date: data.ClockIn,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        TrackMileage: data.TrackMileage,
        OdometerValue: data.OdometerValue,
        OdometerPhoto: data.OdometerPhoto,
      };
      odometerReadingRecordId = await this.createOpenOdometerReadingIfNeeded(who, createOpenOdometerReadingIfNeededData, transaction);

      // Create OdometerReadingMedia for the new odometer reading if photo was provided
      if(odometerReadingRecordId && data.OdometerPhoto) {
        startOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(odometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.Start, transaction);
      }
      await this.validateNoOrphanedNotableActivities(data.UserId, data.ClockIn, transaction);

      const createSyncActionData = {
        ...data,
        ...closeWorkingTimeResult,
        ...createOpenTimeResult,
        ExistingTimeRecord: existingTimeRecord,
        OdometerReadingRecordId: odometerReadingRecordId,
        ExistingOdometerReading: existingOdometerReading,
        EndOdometerReadingMediaRecordId: endOdometerReadingMediaRecordId,
        StartOdometerReadingMediaRecordId: startOdometerReadingMediaRecordId,
        ClosedOdometerReadingRecordId: closedOdometerReadingRecordId,
      };
      await this.createStartMealBreakSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: StartMealBreakResultDto = {
      ...closeWorkingTimeResult,
      ...createOpenTimeResult,
      BreakActivityRecordId: createOpenTimeResult.ClockStartActivityRecordId,
      OdometerReadingRecordId: odometerReadingRecordId,
    };
    this.logService.event('Time.StartMealBreakCompleted', { newBreakTimeRecordId: createOpenTimeResult.TimeRecordRecordId, closedWorkingTimeRecordId: closeWorkingTimeResult?.ClockOutActivityRecordId, odometerReadingRecordId });
    return result;
  }

  async endMealBreak(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: EndMealBreakDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<EndMealBreakResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let createOpenTimeResult: CreateOpenTimeResultDto;
    let odometerReadingRecordId: number;
    let startOdometerReadingMediaRecordId: number | null;
    let endOdometerReadingMediaRecordId: number | null;
    let closedOdometerReadingRecordId: number | null;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      const existingOdometerReading = await this.odometerReadingService.getOpenOdometerReading(data.UserId, existingTimeRecord.ClockIn, transaction);
      const activityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateEndMealBreak(data, existingTimeRecord, transaction);

      const closeBreakTimeData = {
        ...data,
        UserId: existingTimeRecord.EmployeeId,
        ActivityLogRecordId: activityLog.RecordId,
      };
      await this.closeMealBreakTime(who, openTimeRecordRecordId, closeBreakTimeData, skipLocalCopyValidation, localCopy, transaction);

      const closeOdometerReadingIfNeededData = {
        UserId: existingTimeRecord.EmployeeId,
        Date: existingTimeRecord.ClockIn,
        OdometerValue: data.OdometerValue,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        OdometerPhoto: data.OdometerPhoto,
      };
      closedOdometerReadingRecordId = await this.closeOdometerReadingIfNeeded(who, closeOdometerReadingIfNeededData, true, null, transaction); // Note: local copy check not yet implemented for odometer readings

      // Create OdometerReadingMedia for the existing odometer reading being closed if photo was provided
      if (closedOdometerReadingRecordId && data.OdometerPhoto) {
        endOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(closedOdometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.End, transaction);
      }

      const createOpenTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Working,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createOpenTimeResult = await this.createOpenTime(who, createOpenTimeData, transaction);

      const createOpenOdometerReadingIfNeededData = {
        ActivityLogRecordId: createOpenTimeResult.ActivityLogRecordId,
        UserId: data.UserId,
        Date: data.ClockIn,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        TrackMileage: data.TrackMileage,
        OdometerValue: data.OdometerValue,
        OdometerPhoto: data.OdometerPhoto,
      };
      odometerReadingRecordId = await this.createOpenOdometerReadingIfNeeded(who, createOpenOdometerReadingIfNeededData, transaction);

      // Create OdometerReadingMedia for the new odometer reading if photo was provided
      startOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(odometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.Start, transaction);

      const createSyncActionData = {
        ...data,
        ...createOpenTimeResult,
        ExistingTimeRecord: existingTimeRecord,
        OdometerReadingRecordId: odometerReadingRecordId,
        ExistingOdometerReading: existingOdometerReading,
        StartOdometerReadingMediaRecordId: startOdometerReadingMediaRecordId,
        EndOdometerReadingMediaRecordId: endOdometerReadingMediaRecordId,
        ClosedOdometerReadingRecordId: closedOdometerReadingRecordId,
      };
      await this.createEndMealBreakSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: EndMealBreakResultDto = {
      ...createOpenTimeResult,
      ClockInActivityRecordId: createOpenTimeResult.ClockStartActivityRecordId,
      OdometerReadingRecordId: odometerReadingRecordId,
    };
    this.logService.event('Time.EndMealBreakCompleted', { resumedWorkingTimeRecordId: createOpenTimeResult.TimeRecordRecordId, odometerReadingRecordId });
    return result;
  }

  async cancelMealBreak(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: CancelMealBreakDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<number> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let existingTimeRecord: TimeRecord;
    let existingActivities: Activity[];
    let createOpenTimeResult: CreateOpenTimeResultDto;
    let syncActionRecordId: number;

    try {
      existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      existingActivities = await this.getActivitiesForTimeRecord(existingTimeRecord, transaction);

      await this.validateCancelMealBreak(data, existingTimeRecord, transaction);

      await this.timeRecordService.softDeleteTimeRecord(who, openTimeRecordRecordId, skipLocalCopyValidation, localCopy, transaction);
      await Promise.all(existingActivities.map(activity => this.activityService.softDeleteActivity(who, activity.RecordId, true, null, transaction)));

      const createOpenTimeData = {
        UserId: existingTimeRecord.EmployeeId,
        ProjectId: existingTimeRecord.ProjectId,
        TaskId: existingTimeRecord.TaskId,
        LaborCategoryId: existingTimeRecord.LaborCategoryId,
        FIPSStateId: existingTimeRecord.FIPSStateId,
        Coordinates: data.Coordinates,
        ClockIn: existingTimeRecord.ClockIn,
        ClockInTimeZoneId: existingTimeRecord.ClockInTimeZoneId,
        CapturedClockIn: data.CapturedDateTime,
        CapturedClockInTimeZoneId: data.CapturedDateTimeTimeZoneId,
        InputType: data.InputType,
        TimeRecordActivity: TimeRecordActivity.Working,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createOpenTimeResult = await this.createOpenTime(who, createOpenTimeData, transaction);

      await this.validateNoOrphanedNotableActivities(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);

      const createSyncActionData = {
        ...data,
        ...createOpenTimeResult,
        ExistingTimeRecord: existingTimeRecord,
        ExistingActivities: existingActivities,
      };
      syncActionRecordId = await this.createCancelMealBreakSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.CancelMealBreakCompleted', {
      cancelledBreakTimeRecordId: openTimeRecordRecordId,
      resumedWorkingTimeRecordId: createOpenTimeResult.TimeRecordRecordId,
      syncActionRecordId,
    });
    return syncActionRecordId;
  }

  async cancelRestBreak(
    who: DataChangeEmitWho,
    restBreakTimeRecordRecordId: number,
    data: CancelRestBreakDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<number> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let existingBreakTimeRecord: TimeRecord;
    let existingWorkingTimeRecord: TimeRecord;
    let existingBreakActivities: Activity[];
    let existingWorkingClockActivities: Activity[];
    let syncActionRecordId: number;

    try {
      existingBreakTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(restBreakTimeRecordRecordId, transaction);
      existingWorkingTimeRecord = await this.timeRecordService.getOpenTimeRecord(existingBreakTimeRecord.EmployeeId, existingBreakTimeRecord.ClockIn, transaction);
      existingBreakActivities = await this.getActivitiesForTimeRecord(existingBreakTimeRecord, transaction);
      existingWorkingClockActivities = await this.getActivitiesForTimeRecord(existingWorkingTimeRecord, transaction);

      await this.validateCancelRestBreak(data, existingBreakTimeRecord, existingWorkingTimeRecord, transaction);

      await this.timeRecordService.softDeleteTimeRecord(who, restBreakTimeRecordRecordId, skipLocalCopyValidation, localCopy, transaction);
      await Promise.all(existingBreakActivities.map(activity => this.activityService.softDeleteActivity(who, activity.RecordId, true, null, transaction)));

      const updateTimeRecordClocksData = {
        InputType: data.InputType,
        ClockIn: existingBreakTimeRecord.ClockIn,
        ClockInTimeZoneId: existingBreakTimeRecord.ClockInTimeZoneId,
        ClockOut: existingWorkingTimeRecord.ClockOut,
        ClockOutTimeZoneId: existingWorkingTimeRecord.ClockOutTimeZoneId,
        CapturedDateTime: data.CapturedDateTime,
        CapturedDateTimeTimeZoneId: data.CapturedDateTimeTimeZoneId,
      };
      await this.timeRecordService.updateTimeRecordClocks(who, existingWorkingTimeRecord.RecordId, updateTimeRecordClocksData, false, existingWorkingTimeRecord, transaction);

      const workingClockStartActivityType = this.getClockStartActivityType(existingWorkingTimeRecord.Activity);
      const workingClockStartActivity = existingWorkingClockActivities.find(activity => activity.Type === workingClockStartActivityType);
      if (!workingClockStartActivity) {
        throw new ValidationException('This break is no longer active. Refresh your time and try again.');
      }

      const updateClockActivityData = {
        ActivityLogRecordId: existingWorkingTimeRecord.ActivityLogRecordId,
        TimeRecordRecordId: existingWorkingTimeRecord.RecordId,
        TimeRecordId: existingWorkingTimeRecord.Id,
        ActivityLogId: existingWorkingTimeRecord.ActivityLogId,
        ActivityDate: existingBreakTimeRecord.ClockIn,
        TimeZoneId: existingBreakTimeRecord.ClockInTimeZoneId,
        Coordinates: {
          Latitude: workingClockStartActivity.Latitude,
          Longitude: workingClockStartActivity.Longitude,
        },
      };
      await this.activityService.updateClockActivity(who, workingClockStartActivity.RecordId, updateClockActivityData, false, workingClockStartActivity, transaction);

      await this.validateNoOrphanedNotableActivities(existingBreakTimeRecord.EmployeeId, existingBreakTimeRecord.ClockIn, transaction);

      const createSyncActionData = {
        ...data,
        ExistingBreakTimeRecord: existingBreakTimeRecord,
        ExistingBreakActivities: existingBreakActivities,
        ExistingWorkingTimeRecord: existingWorkingTimeRecord,
        ExistingWorkingClockActivities: existingWorkingClockActivities,
      };
      syncActionRecordId = await this.createCancelRestBreakSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.CancelRestBreakCompleted', {
      cancelledBreakTimeRecordId: restBreakTimeRecordRecordId,
      resumedWorkingTimeRecordId: existingWorkingTimeRecord.RecordId,
      syncActionRecordId,
    });
    return syncActionRecordId;
  }

  async startNewAssignment(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: StartNewAssignmentDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<StartNewAssignmentResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let closeWorkingTimeResult: CloseWorkingTimeResultDto;
    let createOpenTimeResult: CreateOpenTimeResultDto;
    let openOdometerReadingRecordId: number;
    let closedOdometerReadingRecordId: number | null;
    let startOdometerReadingMediaRecordId: number | null;
    let endOdometerReadingMediaRecordId: number | null;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      const existingOdometerReading = await this.odometerReadingService.getOpenOdometerReading(data.UserId, existingTimeRecord.ClockIn, transaction);
      const activityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateStartNewAssignment(data, existingTimeRecord, transaction);

      const closeWorkingTimeData = {
        ...data,
        UserId: existingTimeRecord.EmployeeId,
        ActivityLogRecordId: activityLog.RecordId,
      };
      closeWorkingTimeResult = await this.closeWorkingTime(who, openTimeRecordRecordId, closeWorkingTimeData, skipLocalCopyValidation, localCopy, transaction);

      const closeOdometerReadingIfNeededData = {
        UserId: existingTimeRecord.EmployeeId,
        Date: existingTimeRecord.ClockIn,
        OdometerValue: data.OdometerValue,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        OdometerPhoto: data.OdometerPhoto
      };
      closedOdometerReadingRecordId = await this.closeOdometerReadingIfNeeded(who, closeOdometerReadingIfNeededData, true, null, transaction); // Note: local copy check not yet implemented for odometer readings

      // Create OdometerReadingMedia for the existing odometer reading being closed if photo was provided
      if (closedOdometerReadingRecordId && data.OdometerPhoto) {
        endOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(existingOdometerReading.RecordId, data.OdometerPhoto, OdometerPhotoType.End, transaction);
      }

      const createOpenTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Working,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createOpenTimeResult = await this.createOpenTime(who, createOpenTimeData, transaction);

      const createOpenOdometerReadingIfNeededData = {
        ActivityLogRecordId: createOpenTimeResult.ActivityLogRecordId,
        UserId: data.UserId,
        Date: data.ClockIn,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: data.ProjectId,
        TrackMileage: data.TrackMileage,
        OdometerValue: data.OdometerValue,
        OdometerPhoto: data.OdometerPhoto,
      };
      openOdometerReadingRecordId = await this.createOpenOdometerReadingIfNeeded(who, createOpenOdometerReadingIfNeededData, transaction);

      // Create OdometerReadingMedia for the new odometer reading if photo was provided
      if(openOdometerReadingRecordId && data.OdometerPhoto) {
        startOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(openOdometerReadingRecordId, data.OdometerPhoto, OdometerPhotoType.Start, transaction);
      }
      await this.validateNoOrphanedNotableActivities(data.UserId, data.ClockIn, transaction);

      const createSyncActionData = {
        ...data,
        ...closeWorkingTimeResult,
        ...createOpenTimeResult,
        ExistingTimeRecord: existingTimeRecord,
        OdometerReadingRecordId: openOdometerReadingRecordId,
        ExistingOdometerReading: existingOdometerReading,
        StartOdometerReadingMediaRecordId: startOdometerReadingMediaRecordId,
        EndOdometerReadingMediaRecordId: endOdometerReadingMediaRecordId,
        ClosedOdometerReadingRecordId: closedOdometerReadingRecordId
      };
      
      await this.createStartNewAssignmentSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: StartNewAssignmentResultDto = {
      ...closeWorkingTimeResult,
      ...createOpenTimeResult,
      ClockInActivityRecordId: createOpenTimeResult.ClockStartActivityRecordId,
      OdometerReadingRecordId: openOdometerReadingRecordId,
    };
    this.logService.event('Time.StartNewAssignmentCompleted', { newTimeRecordId: createOpenTimeResult.TimeRecordRecordId, previousClosedActivityId: closeWorkingTimeResult?.ClockOutActivityRecordId, openOdometerReadingRecordId });
    return result;
  }

  async clockOut(
    who: DataChangeEmitWho,
    openTimeRecordRecordId: number,
    data: ClockOutDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<CloseWorkingTimeResultDto> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let closeWorkingTimeResult: CloseWorkingTimeResultDto;
    let odometerReadingRecordId: number;
    let odometerReadingMediaRecordId: number | null;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(openTimeRecordRecordId, transaction);
      const existingOdometerReading = await this.odometerReadingService.getOpenOdometerReading(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
      const activityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateClockOut(data, existingTimeRecord, transaction);

      const closeWorkingTimeData = {
        ...data,
        UserId: existingTimeRecord.EmployeeId,
        ActivityLogRecordId: activityLog.RecordId,
      };
      closeWorkingTimeResult = await this.closeWorkingTime(who, openTimeRecordRecordId, closeWorkingTimeData, skipLocalCopyValidation, localCopy, transaction);

      const closeOdometerReadingIfNeededData = {
        UserId: existingTimeRecord.EmployeeId,
        Date: existingTimeRecord.ClockIn,
        OdometerValue: data.OdometerValue,
        CurrentProjectId: existingTimeRecord.ProjectId,
        NextProjectId: null
      };
      odometerReadingRecordId = await this.closeOdometerReadingIfNeeded(who, closeOdometerReadingIfNeededData, true, null, transaction); // Note: local copy check not yet implemented for odometer readings

      // Create OdometerReadingMedia if photo was provided and there's an existing open odometer reading
      if (existingOdometerReading && data.OdometerPhoto) {
        odometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(existingOdometerReading.RecordId, data.OdometerPhoto, OdometerPhotoType.End, transaction);
      }

      await this.validateNoOrphanedNotableActivities(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);

      const createSyncActionData = {
        ...data,
        ...closeWorkingTimeResult,
        ExistingTimeRecord: existingTimeRecord,
        LocalCopy: localCopy,
        OdometerReadingRecordId: odometerReadingRecordId,
        ExistingOdometerReading: existingOdometerReading,
        OdometerReadingMediaRecordId: odometerReadingMediaRecordId,
      };
      await this.createClockOutSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: CloseWorkingTimeResultDto = {
      ...closeWorkingTimeResult,
    };
    this.logService.event('Time.ClockOutCompleted', { timeRecordId: openTimeRecordRecordId });
    return result;
  }

  private async createOpenTime(who: DataChangeEmitWho, data: CreateOpenTimeDataDto, transaction: DbTransaction): Promise<CreateOpenTimeResultDto> {
    const createOpenActivityLogOrReopenData = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      ActivityDate: data.ClockIn,
    };
    const { RecordId: activityLogRecordId, IsNew: activityLogIsNew } = await this.activityLogService.createOpenActivityLogOrReopen(who, createOpenActivityLogOrReopenData, transaction);
    const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);

    const createOpenTimeRecordData = {
      UserId: data.UserId,
      EmployeeNumber: data.EmployeeNumber,
      Activity: data.TimeRecordActivity,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      ActivityLogRecordId: activityLogRecordId,
      OrganizationId: data.OrganizationId,
      ClockIn: data.ClockIn,
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      CapturedClockIn: data.CapturedClockIn,
      CapturedClockInTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
    };
    const timeRecordRecordId = await this.timeRecordService.createOpenTimeRecord(who, createOpenTimeRecordData, transaction);

    const createClockActivityData = {
      Type: this.getClockStartActivityType(data.TimeRecordActivity),
      UserId: data.UserId,
      ActivityDate: data.ClockIn,
      TimeZoneId: data.ClockInTimeZoneId,
      Coordinates: data.Coordinates,
      ActivityLogRecordId: activityLogRecordId,
      TimeRecordRecordId: timeRecordRecordId,
      ActivityLogId: activityLog.Id,
      TimeRecordId: null,
    };
    const clockStartActivityRecordId = await this.activityService.createClockActivity(who, createClockActivityData, transaction);

    return {
      ActivityLogIsNew: activityLogIsNew,
      ActivityLogRecordId: activityLogRecordId,
      TimeRecordRecordId: timeRecordRecordId,
      ClockStartActivityRecordId: clockStartActivityRecordId,
    };
  }

  private async closeWorkingTime(
    who: DataChangeEmitWho,
    timeRecordRecordId: number,
    data: CloseWorkingTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    transaction: DbTransaction
  ): Promise<CloseWorkingTimeResultDto> {
    const closeTimeRecordData = {
      ClockOut: data.ClockOut,
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedClockOut: data.CapturedClockOut,
      CapturedClockOutTimeZoneId: data.CapturedClockOutTimeZoneId,
    };
    await this.timeRecordService.closeTimeRecord(who, timeRecordRecordId, closeTimeRecordData, skipLocalCopyValidation, localCopy, transaction);
    const timeRecord = await this.timeRecordService.getTimeRecordByRecordId(timeRecordRecordId, transaction);

    const createClockActivityData = {
      Type: ActivityType.ClockOut,
      UserId: data.UserId,
      ActivityDate: data.ClockOut,
      TimeZoneId: data.ClockOutTimeZoneId,
      Coordinates: data.Coordinates,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: timeRecordRecordId,
      ActivityLogId: timeRecord.ActivityLogId,
      TimeRecordId: timeRecord.Id,
    };
    const clockOutActivityRecordId = await this.activityService.createClockActivity(who, createClockActivityData, transaction);

    return { ClockOutActivityRecordId: clockOutActivityRecordId };
  }

  private async closeMealBreakTime(
    who: DataChangeEmitWho,
    timeRecordRecordId: number,
    data: CloseMealBreakTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    transaction: DbTransaction
  ): Promise<void> {
    const closeTimeRecordData = {
      ClockOut: data.ClockOut,
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedClockOut: data.CapturedClockOut,
      CapturedClockOutTimeZoneId: data.CapturedClockOutTimeZoneId,
    };
    await this.timeRecordService.closeTimeRecord(who, timeRecordRecordId, closeTimeRecordData, skipLocalCopyValidation, localCopy, transaction);

    return;
  }

  async createClosedWorkingTime(who: DataChangeEmitWho, data: CreateClosedWorkingTimeDataDto, existingTransaction?: DbTransaction): Promise<CreateClosedWorkingTimeResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let createClosedTimeResult: CreateClosedTimeResultDto;

    try {
      await this.validateClosedWorkingTimeCreation(data, transaction);

      const createClosedTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Working,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createClosedTimeResult = await this.createClosedTime(who, createClosedTimeData, transaction);

      const createSyncActionData = {
        ...data,
        ...createClosedTimeResult,
      };
      await this.createClosedWorkingTimeSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: CreateClosedWorkingTimeResultDto = {
      ...createClosedTimeResult,
      ClockInActivityRecordId: createClosedTimeResult.ClockStartActivityRecordId,
      ClockOutActivityRecordId: createClosedTimeResult.ClockOutActivityRecordId,
    };
    this.logService.event('Time.CreateClosedWorkingTimeCompleted', { timeRecordId: createClosedTimeResult.TimeRecordRecordId });
    return result;
  }

  async createClosedRestBreakTime(who: DataChangeEmitWho, data: CreateClosedRestBreakTimeDataDto, existingTransaction?: DbTransaction): Promise<CreateClosedRestBreakTimeResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.FIPSState]);
    let createClosedTimeResult: CreateClosedTimeResultDto;

    try {
      await this.validateClosedRestBreakTimeCreation(data, transaction);

      const createClosedTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Rest,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
        ClockOut: DateTimeHelper.addTime(data.ClockIn, TimeRecordConstants.REST_BREAK_DURATION_MINUTES, 'minutes'),
        ClockOutTimeZoneId: data.ClockInTimeZoneId,
        CapturedClockOut: data.CapturedClockIn,
        CapturedClockOutTimeZoneId: data.CapturedClockInTimeZoneId,
      };
      createClosedTimeResult = await this.createClosedTime(who, createClosedTimeData, transaction);

      const createSyncActionData = {
        ...data,
        ...createClosedTimeResult,
      };
      await this.createClosedRestBreakTimeSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: CreateClosedRestBreakTimeResultDto = {
      ...createClosedTimeResult,
      BreakActivityRecordId: createClosedTimeResult.ClockStartActivityRecordId,
    };
    this.logService.event('Time.CreateClosedRestBreakTimeCompleted', { timeRecordId: createClosedTimeResult.TimeRecordRecordId });
    return result;
  }

  async createClosedMealBreakTime(who: DataChangeEmitWho, data: CreateClosedMealBreakTimeDataDto, existingTransaction?: DbTransaction): Promise<CreateClosedMealBreakTimeResultDto> {
    const user = await this.userService.getUserByOnlineId(data.UserId);

    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let createClosedTimeResult: CreateClosedTimeResultDto;

    try {
      await this.validateClosedMealBreakTimeCreation(data, transaction);

      const createClosedTimeData = {
        ...data,
        TimeRecordActivity: TimeRecordActivity.Meal,
        EmployeeNumber: user.EmployeeNumber,
        OrganizationId: user.OrganizationId,
      };
      createClosedTimeResult = await this.createClosedTime(who, createClosedTimeData, transaction);

      const createSyncActionData = {
        ...data,
        ...createClosedTimeResult,
      };
      await this.createClosedMealBreakTimeSyncAction(createSyncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    const result: CreateClosedMealBreakTimeResultDto = {
      ...createClosedTimeResult,
      BreakActivityRecordId: createClosedTimeResult.ClockStartActivityRecordId,
    };
    this.logService.event('Time.CreateClosedMealBreakTimeCompleted', { timeRecordId: createClosedTimeResult.TimeRecordRecordId });
    return result;
  }

  private async createClosedTime(who: DataChangeEmitWho, data: CreateClosedTimeDataDto, transaction: DbTransaction): Promise<CreateClosedTimeResultDto> {
    const createOpenActivityLogOrReopenData = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      ActivityDate: data.ClockIn,
    };
    const { RecordId: activityLogRecordId, IsNew: activityLogIsNew } = await this.activityLogService.createOpenActivityLogOrReopen(who, createOpenActivityLogOrReopenData, transaction);
    const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);

    const createClosedTimeRecordData = {
      UserId: data.UserId,
      EmployeeNumber: data.EmployeeNumber,
      Activity: data.TimeRecordActivity,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      ActivityLogRecordId: activityLogRecordId,
      OrganizationId: data.OrganizationId,
      ClockIn: data.ClockIn,
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      CapturedClockIn: data.CapturedClockIn,
      CapturedClockInTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      ClockOut: data.ClockOut,
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedClockOut: data.CapturedClockIn,
      CapturedClockOutTimeZoneId: data.CapturedClockInTimeZoneId,
    };
    const timeRecordRecordId = await this.timeRecordService.createClosedTimeRecord(who, createClosedTimeRecordData, transaction);

    const createClockInActivityData = {
      Type: this.getClockStartActivityType(data.TimeRecordActivity),
      UserId: data.UserId,
      ActivityDate: data.ClockIn,
      TimeZoneId: data.ClockInTimeZoneId,
      Coordinates: data.Coordinates,
      ActivityLogRecordId: activityLogRecordId,
      TimeRecordRecordId: timeRecordRecordId,
      ActivityLogId: activityLog.Id,
      TimeRecordId: null,
    };
    const [clockStartActivityRecordId, clockOutActivityRecordId] = await Promise.all([
      this.activityService.createClockActivity(who, createClockInActivityData, transaction),
      data.TimeRecordActivity === TimeRecordActivity.Working ? this.activityService.createClockActivity(who, { ...createClockInActivityData, Type: ActivityType.ClockOut }, transaction) : null,
    ]);

    return {
      ActivityLogIsNew: activityLogIsNew,
      ActivityLogRecordId: activityLogRecordId,
      TimeRecordRecordId: timeRecordRecordId,
      ClockStartActivityRecordId: clockStartActivityRecordId,
      ClockOutActivityRecordId: clockOutActivityRecordId,
    };
  }

  async createNotableActivity(who: DataChangeEmitWho, data: CreateNotableActivityTimeDataDto, existingTransaction?: DbTransaction): Promise<number> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let activityRecordId: number;

    try {
      await this.validateNotableActivityCreation(data, transaction);

      const parentTimeRecord = await this.timeRecordService.getTimeRecordEnclosingDatetime(data.UserId, data.ActivityDate, data.TimeZoneId, transaction);
      const parentActivityLog = await this.getActivityLogForTimeRecord(parentTimeRecord, transaction);

      const createNotableActivityData = {
        ...data,
        TimeRecordRecordId: parentTimeRecord.RecordId,
        ActivityLogRecordId: parentActivityLog.RecordId,
        TimeRecordId: parentTimeRecord.Id,
        ActivityLogId: parentActivityLog.Id,
      };
      activityRecordId = await this.activityService.createNotableActivity(who, createNotableActivityData, transaction);

      const syncActionData = {
        ...data,
        ActivityRecordId: activityRecordId,
      };
      await this.createCreateNotableActivitySyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.CreateNotableActivityCompleted', { activityRecordId });
    return activityRecordId;
  }

  async createFlexDocActivity(who: DataChangeEmitWho, data: CreateFlexDocActivityTimeDataDto, existingTransaction?: DbTransaction): Promise<CreateFlexDocActivityTimeResultDto> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const createOpenActivityLogOrReopenData = {
        UserId: data.UserId,
        ProjectId: data.ProjectId,
        ActivityDate: data.ActivityDate,
      };
      const { RecordId: activityLogRecordId, IsNew: activityLogIsNew } = await this.activityLogService.createOpenActivityLogOrReopen(who, createOpenActivityLogOrReopenData, transaction);
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);

      const createFlexDocData = {
        ...data,
        ActivityLogRecordId: activityLogRecordId,
        ActivityLogId: activityLog.Id,
      };
      let activityRecordId = await this.activityService.createFlexDocActivity(who, createFlexDocData, transaction);

      const syncActionData = {
        ...data,
        ActivityLogIsNew: activityLogIsNew,
        ActivityLogRecordId: activityLogRecordId,
        ActivityRecordId: activityRecordId,
      };
      await this.createCreateFlexDocActivitySyncAction(syncActionData, transaction);

      const result: CreateFlexDocActivityTimeResultDto = {
        ActivityLogIsNew: activityLogIsNew,
        ActivityLogRecordId: activityLogRecordId,
        ActivityRecordId: activityRecordId,
      };
      this.logService.event('Time.CreateFlexDocActivityCompleted', { activityRecordId });
      return result;
    } catch (err) {
      transaction.rollback();
      throw err;
    }
  }

  private async createOpenOdometerReadingIfNeeded(who: DataChangeEmitWho, data: CreateOpenOdometerReadingIfNeededDataDto, existingTransaction?: DbTransaction): Promise<number | null> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      if (await this.checkOdometerReadingOpeningIsNeeded(data.CurrentProjectId, data.NextProjectId, data, transaction)) {
        const createOpenOdometerReadingData = {
          UserId: data.UserId,
          ActivityLogRecordId: data.ActivityLogRecordId,
          OdometerStart: data.OdometerValue!,
          Date: data.Date,
        };
        const odometerReadingRecordId = await this.odometerReadingService.createOpenOdometerReading(who, createOpenOdometerReadingData, transaction);
        return odometerReadingRecordId;
      }
      return null;
    } catch (err) {
      transaction.rollback();
      throw err;
    }
  }

  async createOdometerReading(who: DataChangeEmitWho, data: CreateOdometerReadingTimeDataDto, existingTransaction?: DbTransaction): Promise<number> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let odometerReadingRecordId: number;
    let startOdometerReadingMediaRecordId: number | null = null;
    let endOdometerReadingMediaRecordId: number | null = null;

    try {
      await this.validateOdometerReadingCreation(data, transaction);

      const activityLog = await this.activityLogService.getActivityLogByUserIdProjectIdDate(data.UserId, data.ProjectId, data.Date, transaction);

      if (!data.OdometerEnd) {
        const createOpenOdometerReadingData = {
          UserId: data.UserId,
          Date: data.Date,
          ActivityLogRecordId: activityLog.RecordId,
          ActivityLogId: activityLog.Id,
          OdometerStart: data.OdometerStart,
        };
        odometerReadingRecordId = await this.odometerReadingService.createOpenOdometerReading(who, createOpenOdometerReadingData, transaction);
      } else {
        const createClosedOdometerReadingData = {
          UserId: data.UserId,
          Date: data.Date,
          ActivityLogRecordId: activityLog.RecordId,
          ActivityLogId: activityLog.Id,
          OdometerStart: data.OdometerStart,
          OdometerEnd: data.OdometerEnd,
        };
        odometerReadingRecordId = await this.odometerReadingService.createClosedOdometerReading(who, createClosedOdometerReadingData, transaction);
      }

      // Create media entries for photos if provided
      startOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(
        odometerReadingRecordId,
        data.StartOdometerPhoto,
        OdometerPhotoType.Start,
        transaction
      );

      // Only create end photo if this is a closed odometer reading
      if (data.OdometerEnd) {
        endOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(
          odometerReadingRecordId,
          data.EndOdometerPhoto,
          OdometerPhotoType.End,
          transaction
        );
      }

      const syncActionData = {
        ...data,
        OdometerReadingRecordId: odometerReadingRecordId,
        StartOdometerReadingMediaRecordId: startOdometerReadingMediaRecordId,
        EndOdometerReadingMediaRecordId: endOdometerReadingMediaRecordId,
      };
      await this.createClosedOdometerReadingSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.CreateOdometerReadingCompleted', { odometerReadingRecordId });
    return odometerReadingRecordId;
  }

  private async createOdometerReadingMediaIfNeeded(
    odometerReadingRecordId: number | null,
    odometerPhoto: PendingPhoto | null,
    odometerPhotoType: OdometerPhotoType,
    existingTransaction?: DbTransaction
  ): Promise<number | null> {
    if (odometerReadingRecordId && odometerPhoto) {
      const odometerReadingMedia: OdometerReadingMedia = {
        OdometerReadingRecordId: odometerReadingRecordId,
        Value: odometerPhoto.dataUrl,
        PhotoType: odometerPhotoType,
        FileFormat: odometerPhoto.format,
        UploadStatus: UploadStatus.Pending,
        CreatedDate: new Date().toISOString(),
      }

      return await this.odometerReadingMediaService.createOdometerReadingMedia(odometerReadingMedia, existingTransaction);
    }
    return null;
  }
  // #endregion
  // #region High-level Update

  async updateTimeClocks(
    who: DataChangeEmitWho,
    timeRecordRecordId: number,
    data: UpdateTimeClocksDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      let promises: Promise<void>[] = [];
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(timeRecordRecordId, transaction);

      await this.validateUpdateTimeClocks(data, existingTimeRecord, transaction);

      const existingActivityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);
      promises.push(this.activityLogService.reopenActivityLog(who, existingActivityLog.RecordId, {}, true, null, transaction));

      const updateTimeRecordClocksData = {
        ...data,
      };
      promises.push(this.timeRecordService.updateTimeRecordClocks(who, timeRecordRecordId, updateTimeRecordClocksData, skipLocalCopyValidation, localCopy, transaction));

      const existingActivities = await this.getActivitiesForTimeRecord(existingTimeRecord, transaction);
      const baseActivityDataDto = {
        ActivityLogRecordId: existingTimeRecord.ActivityLogRecordId,
        TimeRecordRecordId: existingTimeRecord.RecordId,
        TimeRecordId: existingTimeRecord.Id,
        ActivityLogId: existingTimeRecord.ActivityLogId,
      };

      const clockStartActivityType = this.getClockStartActivityType(existingTimeRecord.Activity);
      const clockStartActivity = existingActivities.find(activity => activity.Type === clockStartActivityType);
      const updateClockInActivityData = {
        ...baseActivityDataDto,
        ActivityDate: data.ClockIn,
        TimeZoneId: data.ClockInTimeZoneId,
        Coordinates: { Latitude: clockStartActivity.Latitude, Longitude: clockStartActivity.Longitude },
      };
      promises.push(this.activityService.updateClockActivity(who, clockStartActivity.RecordId, updateClockInActivityData, true, null, transaction));

      const clockOutActivity = existingActivities.find(activity => activity.Type === ActivityType.ClockOut);
      if (clockOutActivity) {
        const updateClockOutActivityData = {
          ...baseActivityDataDto,
          ActivityDate: data.ClockOut,
          TimeZoneId: data.ClockOutTimeZoneId,
          Coordinates: { Latitude: clockOutActivity.Latitude, Longitude: clockOutActivity.Longitude },
        };
        promises.push(this.activityService.updateClockActivity(who, clockOutActivity.RecordId, updateClockOutActivityData, true, null, transaction));
      }

      await Promise.all(promises);

      await this.validateNoOrphanedNotableActivities(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingActivityLog: existingActivityLog,
        ExistingTimeRecord: existingTimeRecord,
        ExistingClockActivities: [clockStartActivity, clockOutActivity].filter(activity => !!activity),
      };
      await this.createUpdateClosedTimeClocksSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.UpdateTimeClocksCompleted', { timeRecordId: timeRecordRecordId });
    return;
  }

  async updateAssignment(
    who: DataChangeEmitWho,
    timeRecordRecordId: number,
    data: UpdateAssignmentDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord | null,
    existingTransaction?: DbTransaction
  ): Promise<UpdateAssignmentResultDto> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let result: UpdateAssignmentResultDto;

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(timeRecordRecordId, transaction);
      const existingActivityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);

      await this.validateUpdateAssignment(data, existingTimeRecord, transaction);

      const createOpenActivityLogOrReopenData = {
        UserId: existingTimeRecord.EmployeeId,
        ProjectId: data.ProjectId,
        ActivityDate: existingTimeRecord.ClockIn,
      };
      const { RecordId: activityLogRecordId, IsNew: activityLogIsNew } = await this.activityLogService.createOpenActivityLogOrReopen(who, createOpenActivityLogOrReopenData, transaction);
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);

      const updateTimeRecordAssignmentData = {
        ProjectId: data.ProjectId,
        TaskId: data.TaskId,
        LaborCategoryId: data.LaborCategoryId,
        FIPSStateId: data.FIPSStateId,
        ActivityLogRecordId: activityLogRecordId,
        ActivityLogId: activityLog.Id,
      };
      await this.timeRecordService.updateTimeRecordAssignment(who, timeRecordRecordId, updateTimeRecordAssignmentData, skipLocalCopyValidation, localCopy, transaction);

      let existingActivities: Activity[] = [];
      let existingOdometerReadings: OdometerReading[] = [];
      if (existingActivityLog.RecordId !== activityLogRecordId) {
        // Move existing activities associated with timeRecord to new activityLog
        existingActivities.push(...(await this.getActivitiesForTimeRecord(existingTimeRecord, transaction)));
        const updateActivityForeignKeysData = {
          ActivityLogRecordId: activityLogRecordId,
          TimeRecordRecordId: timeRecordRecordId,
          ActivityLogId: activityLog.Id,
          TimeRecordId: existingTimeRecord.Id,
        };
        await Promise.all([...existingActivities.map(activity => this.activityService.updateActivityForeignKeys(who, activity.RecordId, updateActivityForeignKeysData, true, null, transaction))]);

        // Move odometerReadings to new activityLog if existing activityLog is going to be deleted and new project allows them
        const activityLogHasTimeRecords = await this.checkActivityLogHasTimeRecords(existingActivityLog, transaction);
        if (!activityLogHasTimeRecords) {
          const newProjectAllowsMileageTracking = await this.checkProjectAllowsMileageTracking(data.ProjectId, transaction);
          existingOdometerReadings = await this.getOdometerReadingsForActivityLog(existingActivityLog, transaction);
          if (existingOdometerReadings.length > 0 && newProjectAllowsMileageTracking) {
            const updateOdometerReadingPromises = existingOdometerReadings.map(existingOdometerReading => {
              const updatedOdometerReading = existingOdometerReading.clone();
              updatedOdometerReading.setActivityLog(activityLog.RecordId, activityLog.Id);
              return this.odometerReadingService.updateOdometerReading(who, updatedOdometerReading, true, null, transaction);
            });
            await Promise.all(updateOdometerReadingPromises);
          }
        }

        await this.deleteActivityLogIfChildless(who, existingActivityLog.RecordId, transaction);
      }

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ActivityLogIsNew: activityLogIsNew,
        ActivityLogRecordId: activityLogRecordId,
        ExistingActivityLog: existingActivityLog,
        ExistingTimeRecord: existingTimeRecord,
        ExistingActivities: existingActivities,
        ExistingOdometerReadings: existingOdometerReadings,
      };
      await this.createUpdateAssignmentSyncAction(syncActionData, transaction);

      result = {
        ActivityLogIsNew: activityLogIsNew,
        ActivityLogRecordId: activityLogRecordId,
      };
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.UpdateAssignmentCompleted', { timeRecordId: timeRecordRecordId });
    return result;
  }

  async submitTime(
    who: DataChangeEmitWho,
    activityLogRecordId: number,
    data: SubmitTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: ActivityLogWithChildrenDto,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);
      const timeRecords = await this.getTimeRecordsForActivityLog(activityLog, transaction);
      const existingRecords = new ActivityLogWithChildrenDto(activityLog, timeRecords);

      // Validate that record counts match
      if (!skipLocalCopyValidation) {
        const checks: Check<ActivityLogWithChildrenDto>[] = [{ name: 'TimeRecordsInActivityLogs', function: this.checkTimeRecordsInActivityLogsMatch }];
        EntityHelper.validateLocalCopy<ActivityLogWithChildrenDto>(localCopy, existingRecords, checks);
      }

      await Promise.all([
        this.activityLogService.submitActivityLog(who, activityLog.RecordId, data, skipLocalCopyValidation, activityLog as ActivityLog, transaction),
        ...timeRecords.map(timeRecord => this.timeRecordService.submitTimeRecord(who, timeRecord.RecordId, data, skipLocalCopyValidation, timeRecord as TimeRecord, transaction)),
      ]);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingRecords: existingRecords,
      };
      await this.createSubmitTimeSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.SubmitTimeCompleted', { activityLogRecordId });
    return;
  }

  async verifyTime(
    who: DataChangeEmitWho,
    activityLogRecordId: number,
    data: VerifyTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: ActivityLogWithChildrenDto,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);
      const timeRecords = await this.getTimeRecordsForActivityLog(activityLog, transaction);
      const existingRecords = new ActivityLogWithChildrenDto(activityLog, timeRecords);

      this.validateTimeVerification(data, existingRecords, transaction);

      // Validate that record counts match
      if (!skipLocalCopyValidation) {
        const checks: Check<ActivityLogWithChildrenDto>[] = [{ name: 'TimeRecordsInActivityLogs', function: this.checkTimeRecordsInActivityLogsMatch }];
        EntityHelper.validateLocalCopy<ActivityLogWithChildrenDto>(localCopy, existingRecords, checks);
      }

      await Promise.all([
        this.activityLogService.verifyActivityLog(who, activityLog.RecordId, data, skipLocalCopyValidation, activityLog as ActivityLog, transaction),
        ...timeRecords.map(timeRecord => this.timeRecordService.verifyTimeRecord(who, timeRecord.RecordId, data, skipLocalCopyValidation, timeRecord as TimeRecord, transaction)),
      ]);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingRecords: existingRecords,
      };
      await this.createVerifyTimeSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.VerifyTimeCompleted', { activityLogRecordId });
    return;
  }

  async approveTime(
    who: DataChangeEmitWho,
    activityLogRecordId: number,
    data: ApproveTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: ActivityLogWithChildrenDto,
    existingTransaction?: DbTransaction
  ): Promise<number> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let actionRecordId: number;

    try {
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);
      const timeRecords = await this.getTimeRecordsForActivityLog(activityLog, transaction);
      const existingRecords = new ActivityLogWithChildrenDto(activityLog, timeRecords);

      this.validateTimeApproval(data, existingRecords, transaction);

      // Validate that record counts match
      if (!skipLocalCopyValidation) {
        const checks: Check<ActivityLogWithChildrenDto>[] = [{ name: 'TimeRecordsInActivityLogs', function: this.checkTimeRecordsInActivityLogsMatch }];
        EntityHelper.validateLocalCopy<ActivityLogWithChildrenDto>(localCopy, existingRecords, checks);
      }

      await Promise.all([
        this.activityLogService.approveActivityLog(who, activityLog.RecordId, data, skipLocalCopyValidation, activityLog as ActivityLog, transaction),
        ...timeRecords.map(timeRecord => this.timeRecordService.approveTimeRecord(who, timeRecord.RecordId, data, skipLocalCopyValidation, timeRecord as TimeRecord, transaction)),
      ]);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingRecords: existingRecords,
      };
      await this.createApproveTimeSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.ApproveTimeCompleted', { activityLogRecordId });
    return actionRecordId;
  }

  async returnTime(
    who: DataChangeEmitWho,
    activityLogRecordId: number,
    data: ReturnTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: ActivityLogWithChildrenDto,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);
      const timeRecords = await this.getTimeRecordsForActivityLog(activityLog, transaction);
      const existingRecords = new ActivityLogWithChildrenDto(activityLog, timeRecords);

      this.validateTimeReturn(data, existingRecords, transaction);

      // Validate that record counts match
      if (!skipLocalCopyValidation) {
        const checks: Check<ActivityLogWithChildrenDto>[] = [{ name: 'TimeRecordsInActivityLogs', function: this.checkTimeRecordsInActivityLogsMatch }];
        EntityHelper.validateLocalCopy<ActivityLogWithChildrenDto>(localCopy, existingRecords, checks);
      }

      await Promise.all([
        this.activityLogService.returnActivityLog(who, activityLog.RecordId, data, skipLocalCopyValidation, activityLog as ActivityLog, transaction),
        ...timeRecords.map(timeRecord => this.timeRecordService.returnTimeRecord(who, timeRecord.RecordId, data, skipLocalCopyValidation, timeRecord as TimeRecord, transaction)),
      ]);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingRecords: existingRecords,
      };
      await this.createReturnTimeSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.ReturnTimeCompleted', { activityLogRecordId });
    return;
  }

  async updateNotableActivity(
    who: DataChangeEmitWho,
    activityRecordId: number,
    data: UpdateNotableActivityDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: Activity,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const existingActivity = await this.activityService.getActivityByRecordId(activityRecordId, transaction);

      await this.validateNotableActivityUpdate(data, existingActivity, transaction);

      const parentTimeRecord = await this.timeRecordService.getTimeRecordEnclosingDatetime(existingActivity.UserId, data.ActivityDate, data.TimeZoneId, transaction);
      if (parentTimeRecord === null) {
        throw new ValidationException('No time record found for the activity date and time zone.');
      }

      const parentActivityLog = await this.getActivityLogForTimeRecord(parentTimeRecord, transaction);

      const notableActivityData = {
        ...data,
        TimeRecordRecordId: parentTimeRecord.RecordId,
        ActivityLogRecordId: parentActivityLog.RecordId,
        Coordinates: { Latitude: existingActivity.Latitude, Longitude: existingActivity.Longitude },
        ActivityLogId: parentActivityLog.Id,
        TimeRecordId: parentTimeRecord.Id,
      };
      await this.activityService.updateNotableActivity(who, activityRecordId, notableActivityData, skipLocalCopyValidation, localCopy, transaction);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingActivity: existingActivity,
      };
      await this.createUpdateNotableActivitySyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.UpdateNotableActivityCompleted', { activityRecordId });
    return;
  }

  async updateOdometerReading(
    who: DataChangeEmitWho,
    odometerReadingRecordId: number,
    data: UpdateOdometerReadingDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: OdometerReading,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    let startOdometerReadingMediaRecordId: number | null = null;
    let endOdometerReadingMediaRecordId: number | null = null;

    try {
      const existingOdometerReading = await this.odometerReadingService.getOdometerReadingByRecordId(odometerReadingRecordId, transaction);

      await this.validateOdometerReadingUpdate(data, existingOdometerReading, transaction);

      const recordToUpdate = new OdometerReading(existingOdometerReading);
      recordToUpdate.setOdometerStart(data.OdometerStart);
      recordToUpdate.setOdometerEnd(data.OdometerEnd);
      const newActivityLog = await this.activityLogService.getActivityLogByUserIdProjectIdDate(existingOdometerReading.UserId, data.ProjectId, existingOdometerReading.Date, transaction);
      recordToUpdate.setActivityLog(newActivityLog.RecordId, newActivityLog.Id);

      await this.odometerReadingService.updateOdometerReading(who, recordToUpdate, skipLocalCopyValidation, localCopy, transaction);

      // Create media entries for photos if provided
      startOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(
        odometerReadingRecordId,
        data.StartOdometerPhoto,
        OdometerPhotoType.Start,
        transaction
      );

      // Only create end photo if odometer reading has an end value
      if (data.OdometerEnd) {
        endOdometerReadingMediaRecordId = await this.createOdometerReadingMediaIfNeeded(
          odometerReadingRecordId,
          data.EndOdometerPhoto,
          OdometerPhotoType.End,
          transaction
        );
      }

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingOdometerReading: existingOdometerReading,
        StartOdometerReadingMediaRecordId: startOdometerReadingMediaRecordId,
        EndOdometerReadingMediaRecordId: endOdometerReadingMediaRecordId,
      };
      await this.createUpdateOdometerReadingSyncAction(syncActionData, transaction);
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    this.logService.event('Time.UpdateOdometerReadingCompleted', { odometerReadingRecordId });
    return;
  }

  private async closeOdometerReadingIfNeeded(who: DataChangeEmitWho, data: CloseOdometerReadingIfNeededDataDto, skipLocalCopyValidation: boolean, localCopy: OdometerReading | null, existingTransaction?: DbTransaction): Promise<number | null> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const openOdometerReading = await this.odometerReadingService.getOpenOdometerReading(data.UserId, data.Date, transaction);
      if (openOdometerReading && data.CurrentProjectId !== data.NextProjectId) {
        const closeOdometerReadingData = {
          OdometerEnd: data.OdometerValue
        };
        await this.odometerReadingService.closeOdometerReading(who, openOdometerReading.RecordId, closeOdometerReadingData, skipLocalCopyValidation, localCopy, transaction);
        return openOdometerReading.RecordId;
      }
      return null;
    } catch (err) {
      transaction.rollback();
      throw err;
    }
  }

  // #endregion
  // #region High-level Delete

  async deleteTime(
    who: DataChangeEmitWho,
    timeRecordRecordId: number,
    data: DeleteTimeDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: TimeRecord,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const existingTimeRecord = await this.timeRecordService.getTimeRecordByRecordId(timeRecordRecordId, transaction);

      await this.validateTimeDeletion(data, existingTimeRecord, transaction);

      await this.timeRecordService.softDeleteTimeRecord(who, timeRecordRecordId, skipLocalCopyValidation, localCopy, transaction);

      const existingActivities = await this.getActivitiesForTimeRecord(existingTimeRecord, transaction);
      await Promise.all([...existingActivities.map(activity => this.activityService.softDeleteActivity(who, activity.RecordId, true, null, transaction))]);

      const existingActivityLog = await this.getActivityLogForTimeRecord(existingTimeRecord, transaction);
      await this.deleteActivityLogIfChildless(who, existingActivityLog.RecordId, transaction);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingActivityLog: existingActivityLog,
        ExistingTimeRecord: existingTimeRecord,
        ExistingActivities: existingActivities,
      };
      await this.createDeleteTimeSyncAction(syncActionData, transaction);
      this.logService.event('Time.TimeDeleted', { timeRecordId: timeRecordRecordId, activityIds: existingActivities.map(activity => activity.RecordId) });
    }
    catch (err) {
      transaction.rollback();
      throw err;
    }

    return;
  }

  async deleteNotableActivity(
    who: DataChangeEmitWho,
    activityRecordId: number,
    data: DeleteNotableActivityDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: Activity,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const existingActivity = await this.activityService.getActivityByRecordId(activityRecordId, transaction);

      await this.validateNotableActivityDeletion(data, existingActivity, transaction);

      await this.activityService.softDeleteActivity(who, activityRecordId, skipLocalCopyValidation, localCopy, transaction);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingActivity: existingActivity,
      };
      await this.createDeleteNotableActivitySyncAction(syncActionData, transaction);
      this.logService.event('Time.NotableActivityDeleted', { activityId: activityRecordId });
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    return;
  }

  async deleteOdometerReading(
    who: DataChangeEmitWho,
    odometerReadingRecordId: number,
    data: DeleteOdometerReadingDataDto,
    skipLocalCopyValidation: boolean,
    localCopy: OdometerReading,
    existingTransaction?: DbTransaction
  ): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    try {
      const existingOdometerReading = await this.odometerReadingService.getOdometerReadingByRecordId(odometerReadingRecordId, transaction);

      await this.validateOdometerReadingDeletion(data, existingOdometerReading, transaction);

      await this.odometerReadingService.softDeleteOdometerReading(who, odometerReadingRecordId, skipLocalCopyValidation, localCopy, transaction);

      const syncActionData = {
        ...data,
        LocalCopy: localCopy,
        ExistingOdometerReading: existingOdometerReading,
      };
      await this.createDeleteOdometerReadingSyncAction(syncActionData, transaction);
      this.logService.event('Time.OdometerReadingDeleted', { odometerReadingId: odometerReadingRecordId });
    } catch (err) {
      transaction.rollback();
      throw err;
    }

    return;
  }

  async deleteActivityLogIfChildless(who: DataChangeEmitWho, activityLogRecordId: number, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const activityLog = await this.activityLogService.getActivityLogByRecordId(activityLogRecordId, transaction);
    const hasTimeRecords = await this.checkActivityLogHasTimeRecords(activityLog, transaction);
    if (!hasTimeRecords) {
      await this.deleteActivityLogOdometerReadings(who, activityLog, transaction);
      await this.activityLogService.softDeleteActivityLog(who, activityLogRecordId, true, null, transaction);
    }
  }

  async deleteActivityLogOdometerReadings(who: DataChangeEmitWho, activityLog: ActivityLog, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const odometerReadings = await this.getOdometerReadingsForActivityLog(activityLog, transaction);
    await Promise.all(odometerReadings.map(reading => this.odometerReadingService.softDeleteOdometerReading(who, reading.RecordId, true, null, transaction)));
  }

  // #endregion
  // #region High-level Validate Action

  async validateTimeModification(userId: number, targetDate: DateTimeType, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    // Currently in Flex, a clock-entry user only can modify their own time and activity records.
    // This does not include verifications/approvals/returns by supervisors, 
    // nor does it it include changes made by payroll to block-entry timecards - neither of those actions pass through this validation.
    const isUserIdCurrentUser = await this.userService.checkIsUserIdCurrentUser(userId);
    if (!isUserIdCurrentUser) {
      throw new ActionValidationException('modify', 'time and activity records', 'you are not authorized to modify time and activity records for this user');
    }
    
    const isTimeVerifiedForDate = await this.checkIsTimeVerifiedForDate(userId, targetDate, transaction);
    if (isTimeVerifiedForDate) {
      throw new ActionValidationException('modify', 'time and activity records', 'they have already been verified');
    }
  }

  async validateClockIn(data: ClockInDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
    await this.validateOdometerReadingWillOpenIfNeeded(null, data.ProjectId, data, transaction);
  }

  async validateClockOut(data: ClockOutDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateOdometerReadingWillCloseIfNeeded(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, data.OdometerValue, existingTimeRecord.ProjectId, null, transaction);
  }

  async validateStartRestBreak(data: StartRestBreakDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.FIPSState]);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);

    if (!await this.checkWorkStateAllowsRestBreaks(data.FIPSStateId, transaction)) {
      throw new ValidationException('Rest breaks are not allowed in the selected work state.');
    }
  }

  async validateStartMealBreak(data: StartMealBreakDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
  }

  async validateEndMealBreak(data: EndMealBreakDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
    await this.validateOdometerReadingDuringProjectTransition(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, existingTimeRecord.ProjectId, data.ProjectId, data, transaction);
  }

  async validateCancelMealBreak(data: CancelMealBreakDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);

    if (!this.timeRecordService.checkIsTimeRecordMealBreak(existingTimeRecord) || !await this.timeRecordService.checkIsTimeRecordOpen(existingTimeRecord, transaction)) {
      throw new ValidationException('This break is no longer active. Refresh your time and try again.');
    }

    if (!DateTimeHelper.checkTimeIsEqual(existingTimeRecord.ClockIn, existingTimeRecord.ClockInTimeZoneId, data.ClockIn, data.ClockInTimeZoneId)) {
      throw new ValidationException('This break is no longer active. Refresh your time and try again.');
    }
  }

  async validateCancelRestBreak(data: CancelRestBreakDataDto, existingBreakTimeRecord: TimeRecord, existingWorkingTimeRecord: TimeRecord | null, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingBreakTimeRecord.EmployeeId, existingBreakTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, existingBreakTimeRecord.ClockIn, transaction);

    if (!this.timeRecordService.checkIsTimeRecordRestBreak(existingBreakTimeRecord)) {
      throw new ValidationException('This break is no longer active. Refresh your time and try again.');
    }

    if (!existingWorkingTimeRecord || !this.timeRecordService.checkIsTimeRecordWorking(existingWorkingTimeRecord) || !await this.timeRecordService.checkIsTimeRecordOpen(existingWorkingTimeRecord, transaction)) {
      throw new ValidationException('This break is no longer active. Refresh your time and try again.');
    }

    if (!DateTimeHelper.checkTimeIsEqual(existingBreakTimeRecord.ClockOut, existingBreakTimeRecord.ClockOutTimeZoneId, existingWorkingTimeRecord.ClockIn, existingWorkingTimeRecord.ClockInTimeZoneId)) {
      throw new ValidationException('This break is no longer active. Refresh your time and try again.');
    }
  }

  async validateClosedWorkingTimeCreation(data: CreateClosedWorkingTimeDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
  }

  async validateClosedRestBreakTimeCreation(data: CreateClosedRestBreakTimeDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.FIPSState]);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);

    if (!await this.checkWorkStateAllowsRestBreaks(data.FIPSStateId, transaction)) {
      throw new ValidationException('Rest breaks are not allowed in the selected work state.');
    }
  }

  async validateClosedMealBreakTimeCreation(data: CreateClosedMealBreakTimeDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
  }

  async validateUpdateTimeClocks(data: UpdateTimeClocksDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
  }

  async validateTimeDeletion(data: DeleteTimeDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
  }

  async validateStartNewAssignment(data: StartNewAssignmentDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
    await this.validateTimeModification(data.UserId, data.ClockIn, transaction);
    await this.validateOdometerReadingDuringProjectTransition(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, existingTimeRecord.ProjectId, data.ProjectId, data, transaction);
  }

  async validateUpdateAssignment(data: UpdateAssignmentDataDto, existingTimeRecord: TimeRecord, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingTimeRecord.EmployeeId, existingTimeRecord.ClockIn, transaction);
  }

  async validateNotableActivityCreation(data: CreateNotableActivityTimeDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(data.UserId, data.ActivityDate, transaction);
  }

  async validateNotableActivityUpdate(data: UpdateNotableActivityDataDto, existingActivity: Activity, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingActivity.UserId, existingActivity.UserSpecifiedDate, transaction);
  }

  async validateNotableActivityDeletion(data: DeleteNotableActivityDataDto, existingActivity: Activity, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingActivity.UserId, existingActivity.UserSpecifiedDate, transaction);
  }

  async validateTimeReturn(data: ReturnTimeDataDto, existingRecords: ActivityLogWithChildrenDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await Promise.all([
      this.activityLogService.validateActivityLogReturn(data, existingRecords as ActivityLog, false, transaction),
      ...existingRecords.TimeRecords.map(timeRecord => this.timeRecordService.validateTimeRecordReturn(data, timeRecord, false, transaction)),
    ]);
  }

  async validateTimeVerification(data: VerifyTimeDataDto, existingRecords: ActivityLogWithChildrenDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await Promise.all([
      this.activityLogService.validateActivityLogVerification(data, existingRecords as ActivityLog, false, transaction),
      ...existingRecords.TimeRecords.map(timeRecord => this.timeRecordService.validateTimeRecordVerification(data, timeRecord, false, transaction)),
    ]);
  }

  async validateTimeApproval(data: ApproveTimeDataDto, existingRecords: ActivityLogWithChildrenDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await Promise.all([
      this.activityLogService.validateActivityLogApproval(data, existingRecords as ActivityLog, false, transaction),
      ...existingRecords.TimeRecords.map(timeRecord => this.timeRecordService.validateTimeRecordApproval(data, timeRecord, false, transaction)),
    ]);
  }

  async validateOdometerReadingCreation(data: CreateOdometerReadingTimeDataDto, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await this.validateTimeModification(data.UserId, data.Date, transaction);

    if (!await this.checkProjectAllowsMileageTracking(data.ProjectId, transaction)) {
      throw new ValidationException('The project does not allow mileage tracking.');
    }

    if (!await this.checkTimeExistsForUserIdProjectIdDate(data.UserId, data.ProjectId, data.Date, transaction)) {
      throw new ValidationException('Time must exist for the user, project, and date in order to record mileage.');
    }

    const hasOpenTime = await this.checkUserHasOpenTimeRecord(data.UserId, data.Date, transaction);
    if (!hasOpenTime && !data.OdometerEnd) {
      throw new ValidationException('Cannot create an open odometer reading without open time.');
    }
  }

  async validateOdometerReadingUpdate(data: UpdateOdometerReadingDataDto, existingOdometerReading: OdometerReading, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await this.validateTimeModification(existingOdometerReading.UserId, existingOdometerReading.Date, transaction);

    if (!await this.checkProjectAllowsMileageTracking(data.ProjectId, transaction)) {
      throw new ValidationException('The project does not allow mileage tracking.');
    }

    if (!await this.checkTimeExistsForUserIdProjectIdDate(existingOdometerReading.UserId, data.ProjectId, existingOdometerReading.Date, transaction)) {
      throw new ValidationException('Time must exist for the user, project, and date in order to record mileage.');
    }
  }

  async validateOdometerReadingDeletion(data: DeleteOdometerReadingDataDto, existingRecord: OdometerReading, existingTransaction?: DbTransaction) {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);
    await this.validateTimeModification(existingRecord.UserId, existingRecord.Date, transaction);
  }

  // #endregion

  // #region High-level Validate State

  async validateNoOrphanedNotableActivities(userId: number, date: DateTimeType, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const notableActivities = await this.activityService.getNotableActivitiesByUserIdDate(userId, date, transaction);
    const timeRecordsForDay = await this.timeRecordService.getTimeRecordsByUserIdDate(userId, date, transaction);

    const orphanedActivities = notableActivities.filter(activity => !this.checkIsActivityInAnyWorkingTimeRecord(activity, timeRecordsForDay));
    if (orphanedActivities.length > 0) {
      throw new ValidationException('Notable activities must be enclosed by a working time record.');
    }
  }

  async validateOdometerReadingWillOpenIfNeeded(currentProjectId: number | null, nextProjectId: number, data: TrackMileageDataDto, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    if (!data.OdometerValue && await this.checkOdometerReadingOpeningIsNeeded(currentProjectId, nextProjectId, data, transaction)) {
      throw new ValidationException('OdometerReading is required for this project.');
    }
  }

  async validateOdometerReadingWillCloseIfNeeded(userId: number, date: DateTimeType, odometerValue: number | null | undefined, currentProjectId: number, nextProjectId: number | null, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    if (!odometerValue && await this.checkOdometerReadingClosingIsNeeded(userId, date, currentProjectId, nextProjectId, transaction)) {
      throw new ValidationException('A closing odometer reading must be provided.');
    }
  }

  async validateOdometerReadingDuringProjectTransition(userId: number, date: DateTimeType, currentProjectId: number, nextProjectId: number, data: TrackMileageDataDto, existingTransaction?: DbTransaction): Promise<void> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    await this.validateOdometerReadingWillCloseIfNeeded(userId, date, data.OdometerValue, currentProjectId, nextProjectId, transaction);
    await this.validateOdometerReadingWillOpenIfNeeded(currentProjectId, nextProjectId, data, transaction);
  }

  // #endregion
  // #region High-level Upsert

  // #endregion
  // #region High-level Sync

  async syncTimeData(fullSync = false, ignoreThrottle = true): Promise<void> {
    await this.syncService.sync({ syncType: SyncType.APP_USER, waitIfProcessing: true, fullSync, ignoreThrottle });
  }

  private async createClockInSyncAction(data: ClockInSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: ClockInAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      ClockInActivityRecordId: data.ClockStartActivityRecordId,
      OdometerReadingRecordId: data.OdometerReadingRecordId,
      OdometerReadingMediaRecordId: data.OdometerReadingMediaRecordId,
    };

    const payload: ClockInPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      ClockIn: DateTimeHelper.formatDateTime(data.ClockIn),
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      CapturedClockIn: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedClockInTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      TrackMileage: data.TrackMileage,
      OdometerValue: data.OdometerValue
    };

    return await this.syncActionService.createAction(SyncActionTypeId.ClockIn, null, auxillaryData, payload, transaction);
  }

  private async createCancelMealBreakSyncAction(data: CancelMealBreakSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: CancelMealBreakAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      ClockInActivityRecordId: data.ClockStartActivityRecordId,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ExistingActivities: data.ExistingActivities,
    };

    const payload: CancelMealBreakPayloadDto = {
      LocalCopy: data.ExistingTimeRecord,
      UserId: data.UserId,
      Coordinates: data.Coordinates,
      SelectedDateTime: DateTimeHelper.formatDateTime(data.ClockIn),
      SelectedDateTimeTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedDateTime),
      CapturedDateTimeTimeZoneId: data.CapturedDateTimeTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CancelMealBreak, params, auxillaryData, payload, transaction);
  }

  private async createCancelRestBreakSyncAction(data: CancelRestBreakSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      timeRecordId: data.ExistingBreakTimeRecord.Id,
    };

    const auxillaryData: CancelRestBreakAuxillaryDto = {
      ExistingBreakTimeRecord: data.ExistingBreakTimeRecord,
      ExistingBreakActivities: data.ExistingBreakActivities,
      ExistingWorkingTimeRecord: data.ExistingWorkingTimeRecord,
      ExistingWorkingClockActivities: data.ExistingWorkingClockActivities,
    };

    const payload: CancelRestBreakPayloadDto = {
      LocalCopy: new CancelRestBreakLocalCopyDto(data.ExistingBreakTimeRecord, data.ExistingWorkingTimeRecord),
      UserId: data.UserId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedDateTime),
      CapturedDateTimeTimeZoneId: data.CapturedDateTimeTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CancelRestBreak, params, auxillaryData, payload, transaction);
  }

  private async createStartRestBreakSyncAction(data: StartRestBreakSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      BreakTimeRecordRecordId: data.BreakTimeRecordRecordId,
      WorkingTimeRecordRecordId: data.WorkingTimeRecordRecordId,
      ClockInActivityRecordId: data.ClockStartActivityRecordId,
      ClockOutActivityRecordId: data.ClockOutActivityRecordId,
      BreakActivityRecordId: data.BreakActivityRecordId,
      ExistingTimeRecord: data.ExistingTimeRecord,
    };

    const payload = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      SelectedDateTime: DateTimeHelper.formatDateTime(data.ClockIn),
      SelectedDateTimeTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      LocalCopy: data.ExistingTimeRecord,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.StartRestBreak, params, auxillaryData, payload, transaction);
  }

  private async createStartMealBreakSyncAction(data: StartMealBreakSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: StartMealBreakAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      BreakActivityRecordId: data.ClockStartActivityRecordId,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ClockOutActivityRecordId: data.ClockOutActivityRecordId,
      OdometerReadingRecordId: data.OdometerReadingRecordId,
      ExistingOdometerReading: data.ExistingOdometerReading,
      StartOdometerReadingMediaRecordId: data.StartOdometerReadingMediaRecordId,
      EndOdometerReadingMediaRecordId: data.EndOdometerReadingMediaRecordId,
      ClosedOdometerReadingRecordId: data.ClosedOdometerReadingRecordId,
    };

    const payload: StartMealBreakPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      SelectedDateTime: DateTimeHelper.formatDateTime(data.ClockIn),
      SelectedDateTimeTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      LocalCopy: data.ExistingTimeRecord,
      TrackMileage: data.TrackMileage,
      OdometerValue: data.OdometerValue,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.StartMealBreak, params, auxillaryData, payload, transaction);
  }

  private async createEndMealBreakSyncAction(data: EndMealBreakSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: EndMealBreakAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      ClockInActivityRecordId: data.ClockStartActivityRecordId,
      ExistingTimeRecord: data.ExistingTimeRecord,
      OdometerReadingRecordId: data.OdometerReadingRecordId,
      ExistingOdometerReading: data.ExistingOdometerReading,
      StartOdometerReadingMediaRecordId: data.StartOdometerReadingMediaRecordId,
      EndOdometerReadingMediaRecordId: data.EndOdometerReadingMediaRecordId,
      ClosedOdometerReadingRecordId: data.ClosedOdometerReadingRecordId,
    };

    const payload: EndMealBreakPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      SelectedDateTime: DateTimeHelper.formatDateTime(data.ClockIn),
      SelectedDateTimeTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      LocalCopy: data.ExistingTimeRecord,
      TrackMileage: data.TrackMileage,
      OdometerValue: data.OdometerValue,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.EndMealBreak, params, auxillaryData, payload, transaction);
  }

  private async createStartNewAssignmentSyncAction(data: StartNewAssignmentSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: StartNewAssignmentAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      ClockInActivityRecordId: data.ClockOutActivityRecordId,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ClockOutActivityRecordId: data.ClockStartActivityRecordId,
      OdometerReadingRecordId: data.OdometerReadingRecordId,
      ExistingOdometerReading: data.ExistingOdometerReading,
      StartOdometerReadingMediaRecordId: data.StartOdometerReadingMediaRecordId,
      EndOdometerReadingMediaRecordId: data.EndOdometerReadingMediaRecordId,
      ClosedOdometerReadingRecordId: data.ClosedOdometerReadingRecordId,
    };

    const payload: StartNewAssignmentPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      SelectedDateTime: DateTimeHelper.formatDateTime(data.ClockIn),
      SelectedDateTimeTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
      LocalCopy: data.ExistingTimeRecord,
      TrackMileage: data.TrackMileage,
      OdometerValue: data.OdometerValue,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.StartNewAssignment, params, auxillaryData, payload, transaction);
  }

  private async createClockOutSyncAction(data: ClockOutSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      openTimeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: ClockOutAuxillaryDto = {
      ExistingTimeRecord: data.ExistingTimeRecord,
      ClockOutActivityRecordId: data.ClockOutActivityRecordId,
      ExistingOdometerReading: data.ExistingOdometerReading,
      OdometerReadingMediaRecordId: data.OdometerReadingMediaRecordId,
      OdometerReadingRecordId: data.OdometerReadingRecordId,
    };

    const payload: ClockOutPayloadDto = {
      LocalCopy: data.ExistingTimeRecord,
      ClockOut: DateTimeHelper.formatDateTime(data.ClockOut),
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedClockOut: DateTimeHelper.formatDateTime(data.CapturedClockOut),
      CapturedClockOutTimeZoneId: data.CapturedClockOutTimeZoneId,
      Coordinates: data.Coordinates,
      InputType: data.InputType,
      OdometerValue: data.OdometerValue,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.ClockOut, params, auxillaryData, payload, transaction);
  }

  private async createClosedWorkingTimeSyncAction(data: CreateClosedWorkingTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateClosedWorkingTimeAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      ClockInActivityRecordId: data.ClockStartActivityRecordId,
      ClockOutActivityRecordId: data.ClockOutActivityRecordId,
    };

    const payload: CreateClosedWorkingTimePayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      ClockIn: DateTimeHelper.formatDateTime(data.ClockIn),
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      ClockOut: DateTimeHelper.formatDateTime(data.ClockOut),
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateClosedWorkingTime, null, auxillaryData, payload, transaction);
  }

  private async createClosedRestBreakTimeSyncAction(data: CreateClosedRestBreakTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateClosedRestBreakTimeAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      BreakActivityRecordId: data.ClockStartActivityRecordId,
    };

    const payload: CreateClosedRestBreakTimePayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      ClockIn: DateTimeHelper.formatDateTime(data.ClockIn),
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateClosedRestBreakTime, null, auxillaryData, payload, transaction);
  }

  private async createClosedMealBreakTimeSyncAction(data: CreateClosedMealBreakTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateClosedMealBreakTimeAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      TimeRecordRecordId: data.TimeRecordRecordId,
      BreakActivityRecordId: data.ClockStartActivityRecordId,
    };

    const payload: CreateClosedMealBreakTimePayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      Coordinates: data.Coordinates,
      ClockIn: DateTimeHelper.formatDateTime(data.ClockIn),
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      ClockOut: DateTimeHelper.formatDateTime(data.ClockOut),
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedClockIn),
      CapturedDateTimeTimeZoneId: data.CapturedClockInTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateClosedMealBreakTime, null, auxillaryData, payload, transaction);
  }

  private async createUpdateClosedTimeClocksSyncAction(data: UpdateTimeClocksSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      timeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: UpdateTimeClocksAuxillaryDto = {
      ExistingActivityLog: data.ExistingActivityLog,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ExistingClockActivities: data.ExistingClockActivities,
    };

    const payload: UpdateTimeClocksPayloadDto = {
      LocalCopy: data.LocalCopy,
      InputType: data.InputType,
      ClockIn: data.ClockIn ? DateTimeHelper.formatDateTime(data.ClockIn) : undefined,
      ClockInTimeZoneId: data.ClockInTimeZoneId,
      ClockOut: data.ClockOut ? DateTimeHelper.formatDateTime(data.ClockOut) : undefined,
      ClockOutTimeZoneId: data.ClockOutTimeZoneId,
      CapturedDateTime: DateTimeHelper.formatDateTime(data.CapturedDateTime),
      CapturedDateTimeTimeZoneId: data.CapturedDateTimeTimeZoneId,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.UpdateTimeClocks, params, auxillaryData, payload, transaction);
  }

  private async createUpdateAssignmentSyncAction(data: UpdateAssignmentSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      timeRecordId: data.ExistingTimeRecord.Id,
    };

    const auxillaryData: UpdateAssignmentAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      ExistingActivityLog: data.ExistingActivityLog,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ExistingActivities: data.ExistingActivities,
      ExistingOdometerReadings: data.ExistingOdometerReadings,
    };

    const payload: UpdateAssignmentPayloadDto = {
      LocalCopy: data.LocalCopy,
      ProjectId: data.ProjectId,
      TaskId: data.TaskId,
      LaborCategoryId: data.LaborCategoryId,
      FIPSStateId: data.FIPSStateId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.UpdateAssignment, params, auxillaryData, payload, transaction);
  }

  private async createSubmitTimeSyncAction(data: SubmitTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityLogId: data.ExistingRecords.Id,
    };

    const auxillaryData: SubmitTimeAuxillaryDto = {
      ExistingRecords: data.ExistingRecords,
    };

    const payload: SubmitTimePayloadDto = {
      LocalCopy: data.LocalCopy,
      SubmittedDate: DateTimeHelper.formatDateTime(data.SubmittedDate),
      SubmittedTimeZoneId: data.SubmittedTimeZoneId,
      Signature: data.Signature,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.SubmitTime, params, auxillaryData, payload, transaction);
  }

  private async createVerifyTimeSyncAction(data: VerifyTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityLogId: data.ExistingRecords.Id,
    };

    const auxillaryData: VerifyTimeAuxillaryDto = {
      ExistingRecords: data.ExistingRecords,
    };

    const payload: VerifyTimePayloadDto = {
      LocalCopy: data.LocalCopy,
      VerifiedDate: DateTimeHelper.formatDateTime(data.VerifiedDate),
      VerifiedTimeZoneId: data.VerifiedTimeZoneId,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.VerifyTime, params, auxillaryData, payload, transaction);
  }

  private async createApproveTimeSyncAction(data: ApproveTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityLogId: data.ExistingRecords.Id,
    };

    const auxillaryData: ApproveTimeAuxillaryDto = {
      ExistingRecords: data.ExistingRecords,
    };

    const payload: ApproveTimePayloadDto = {
      LocalCopy: data.LocalCopy,
      ApprovedDate: DateTimeHelper.formatDateTime(data.ApprovedDate),
      ApprovedTimeZoneId: data.ApprovedTimeZoneId,
      VerifyWhileApproving: data.VerifyWhileApproving,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.ApproveTime, params, auxillaryData, payload, transaction);
  }

  private async createReturnTimeSyncAction(data: ReturnTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityLogId: data.ExistingRecords.Id,
    };

    const auxillaryData: ReturnTimeAuxillaryDto = {
      ExistingRecords: data.ExistingRecords,
    };

    const payload: ReturnTimePayloadDto = {
      LocalCopy: data.LocalCopy,
      ReturnedDate: DateTimeHelper.formatDateTime(data.ReturnedDate),
      ReturnedTimeZoneId: data.ReturnedTimeZoneId,
      Remarks: data.Remarks,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.ReturnTime, params, auxillaryData, payload, transaction);
  }

  private async createCreateNotableActivitySyncAction(data: CreateNotableActivitySyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateNotableActivityAuxillaryDto = {
      ActivityRecordId: data.ActivityRecordId,
    };

    const payload: CreateNotableActivityPayloadDto = {
      UserId: data.UserId,
      Text: data.Text,
      ActivityDate: DateTimeHelper.formatDateTime(data.ActivityDate),
      TimeZoneId: data.TimeZoneId,
      Coordinates: data.Coordinates,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateNotableActivity, null, auxillaryData, payload, transaction);
  }

  private async createCreateFlexDocActivitySyncAction(data: CreateFlexActivitySyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateFlexDocActivityAuxillaryDto = {
      ActivityLogIsNew: data.ActivityLogIsNew,
      ActivityLogRecordId: data.ActivityLogRecordId,
      ActivityRecordId: data.ActivityRecordId,
    };

    const payload: CreateFlexDocActivityPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      FormName: data.FormName,
      DocumentNumber: data.DocumentNumber,
      ActivityDate: DateTimeHelper.formatDateTime(data.ActivityDate),
      TimeZoneId: data.TimeZoneId,
      Coordinates: data.Coordinates,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateFlexDocActivity, null, auxillaryData, payload, transaction);
  }

  private async createUpdateNotableActivitySyncAction(data: UpdateNotableActivitySyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityId: null,
    };

    const auxillaryData: UpdateNotableActivityAuxillaryDto = {
      ExistingActivity: data.ExistingActivity,
    };

    const payload: UpdateNotableActivityPayloadDto = {
      LocalCopy: data.LocalCopy,
      Text: data.Text,
      ActivityDate: DateTimeHelper.formatDateTime(data.ActivityDate),
      TimeZoneId: data.TimeZoneId,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.UpdateNotableActivity, params, auxillaryData, payload, transaction);
  }

  private async createDeleteTimeSyncAction(data: DeleteTimeSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      timeRecordId: null,
    };

    const auxillaryData: DeleteTimeAuxillaryDto = {
      ExistingActivityLog: data.ExistingActivityLog,
      ExistingTimeRecord: data.ExistingTimeRecord,
      ExistingActivities: data.ExistingActivities,
    };

    const payload: DeleteTimePayloadDto = {
      LocalCopy: data.LocalCopy,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.DeleteTime, params, auxillaryData, payload, transaction);
  }

  private async createDeleteNotableActivitySyncAction(data: DeleteNotableActivitySyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      activityId: null,
    };

    const auxillaryData: DeleteNotableActivityAuxillaryDto = {
      ExistingActivity: data.ExistingActivity,
    };

    const payload: DeleteNotableActivityPayloadDto = {
      LocalCopy: data.LocalCopy,
      InputType: data.InputType,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.DeleteNotableActivity, params, auxillaryData, payload, transaction);
  }

  private async createClosedOdometerReadingSyncAction(data: CreateOdometerReadingSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const auxillaryData: CreateOdometerReadingAuxillaryDto = {
      OdometerReadingRecordId: data.OdometerReadingRecordId,
      StartOdometerReadingMediaRecordId: data.StartOdometerReadingMediaRecordId,
      EndOdometerReadingMediaRecordId: data.EndOdometerReadingMediaRecordId,
    };

    const payload: CreateOdometerReadingPayloadDto = {
      UserId: data.UserId,
      ProjectId: data.ProjectId,
      Date: DateTimeHelper.formatDateTime(data.Date),
      OdometerStart: data.OdometerStart,
      OdometerEnd: data.OdometerEnd,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.CreateOdometerReading, null, auxillaryData, payload, transaction);
  }

  private async createUpdateOdometerReadingSyncAction(data: UpdateOdometerReadingSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      odometerReadingId: null,
    };

    const auxillaryData: UpdateOdometerReadingAuxillaryDto = {
      ExistingOdometerReading: data.ExistingOdometerReading,
      StartOdometerReadingMediaRecordId: data.StartOdometerReadingMediaRecordId,
      EndOdometerReadingMediaRecordId: data.EndOdometerReadingMediaRecordId,
    };

    const payload: UpdateOdometerReadingPayloadDto = {
      LocalCopy: data.LocalCopy,
      ProjectId: data.ProjectId,
      OdometerStart: data.OdometerStart,
      OdometerEnd: data.OdometerEnd,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.UpdateOdometerReading, params, auxillaryData, payload, transaction);
  }

  private async createDeleteOdometerReadingSyncAction(data: DeleteOdometerReadingSyncActionDataDto, transaction: DbTransaction): Promise<number> {
    const params = {
      odometerReadingId: null,
    };

    const auxillaryData: DeleteOdometerReadingAuxillaryDto = {
      ExistingOdometerReading: data.ExistingOdometerReading,
    };

    const payload: DeleteOdometerReadingPayloadDto = {
      LocalCopy: data.LocalCopy,
    };

    return await this.syncActionService.createAction(SyncActionTypeId.DeleteOdometerReading, params, auxillaryData, payload, transaction);
  }

  // #endregion
  // #region Build

  // #endregion
  // #region Check

  async checkHasUnsubmittedTimeForDate(userId: number, targetDate: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const activityLogs = await this.activityLogService.getActivityLogsByUserIdDate(userId, targetDate, transaction);
    if (activityLogs.length === 0) {
      return false;
    }

    const checkPromises = activityLogs.map(activityLog => this.activityLogService.checkIsActivityLogOpen(activityLog));
    const results = await Promise.all(checkPromises);
    return results.some(isUnsubmitted => isUnsubmitted);
  }

  async checkHasReturnedTimeForDate(userId: number, targetDate: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const activityLogs = await this.activityLogService.getActivityLogsByUserIdDate(userId, targetDate, transaction);
    if (activityLogs.length === 0) {
      return false;
    }

    const checkPromises = activityLogs.map(activityLog => this.activityLogService.checkIsActivityLogReturned(activityLog));
    const results = await Promise.all(checkPromises);
    return results.some(isReturned => isReturned);
  }

  async checkIsTimeSubmittedForDate(userId: number, targetDate: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const activityLogs = await this.activityLogService.getActivityLogsByUserIdDate(userId, targetDate, transaction);
    if (activityLogs.length === 0) {
      return false;
    }

    const minimumStatus = await this.activityLogService.getMinimumStatusForActivityLogs(activityLogs, transaction);

    return ActivityLogStatusHierarchy.SubmittedStatusNumbers.includes(minimumStatus.Number);
  }

  async checkIsTimeVerifiedForDate(userId: number, targetDate: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const activityLogs = await this.activityLogService.getActivityLogsByUserIdDate(userId, targetDate, transaction);
    if (activityLogs.length === 0) {
      return false;
    }

    const minimumStatus = await this.activityLogService.getMinimumStatusForActivityLogs(activityLogs, transaction);

    return ActivityLogStatusHierarchy.VerifiedStatusNumbers.includes(minimumStatus.Number);
  }

  checkIsActivityInAnyWorkingTimeRecord(activity: Activity, timeRecords: TimeRecord[]) {
    return timeRecords.some(timeRecord =>
      this.timeRecordService.checkIsTimeRecordWorking(timeRecord) &&
      this.timeRecordService.checkDatetimeInTimeRecord(timeRecord, activity.UserSpecifiedDate, activity.TimeZoneId)
    );
  }

  async checkCanEditTime(userId: number): Promise<boolean> {
    const isUserIdCurrentUser = await this.userService.checkIsUserIdCurrentUser(userId);
    if (isUserIdCurrentUser) {
      return true;
    } else {
      return false;
    }
  }

  checkIsTimeRecordInActivityLog(timeRecord: TimeRecord, activityLog: ActivityLog) {
    return activityLog.Id === timeRecord.ActivityLogId || activityLog.RecordId === timeRecord.ActivityLogRecordId;
  }

  checkIsActivityInTimeRecord(activity: Activity, timeRecord: TimeRecord) {
    return this.timeRecordService.checkDatetimeInTimeRecord(timeRecord, activity.UserSpecifiedDate, activity.TimeZoneId);
  }

  checkTimeRecordsInActivityLogsMatch(a: ActivityLogWithChildrenDto, b: ActivityLogWithChildrenDto) {
    const timeRecordRecordIds = a.TimeRecords.map(record => record.RecordId);
    const localCopyTimeRecordRecordIds = b.TimeRecords.map(record => record.RecordId);

    return timeRecordRecordIds.length === localCopyTimeRecordRecordIds.length && timeRecordRecordIds.every(recordId => localCopyTimeRecordRecordIds.includes(recordId));
  }

  async checkActivityLogHasTimeRecords(activityLog: ActivityLog, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const timeRecords = await this.getTimeRecordsForActivityLog(activityLog, transaction);
    return timeRecords.length > 0;
  }

  async checkOdometerReadingOpeningIsNeeded(currentProjectId: number | null, nextProjectId: number, data: TrackMileageDataDto, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    if (currentProjectId === nextProjectId) {
      return false; // No need to open odometer reading if the project is not changing
    }
    if (!await this.checkProjectAllowsMileageTracking(nextProjectId, transaction)) {
      return false; // Project does not require mileage tracking
    }
    if (data.TrackMileage === false) {
      return false; // User reported mileage tracking does not apply to them  
    }
    return true;
  }

  async checkOdometerReadingClosingIsNeeded(userId: number, date: DateTimeType, currentProjectId: number, nextProjectId: number | null, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    if (currentProjectId === nextProjectId) {
      return false; // No need to close odometer reading if the project is not changing
    }
    if (!await this.checkUserHasOpenOdometerReading(userId, date, transaction)) {
      return false; // No open odometer reading to close
    }
    return true;
  }

  async checkProjectAllowsMileageTracking(projectId: number, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const project = await this.projectService.getProjectByOnlineId(projectId, transaction);
    return project.RequireMileage || false;
  }

  async checkWorkStateAllowsRestBreaks(FIPSStateId: number, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction, [StoreName.FIPSState]);

    const FIPSState = await this.fipsStateService.getFIPSStateByOnlineId(FIPSStateId, transaction);
    return FIPSState.RequiresRestBreak || false;
  }

  async checkTimeExistsForUserIdProjectIdDate(userId: number, projectId: number, date: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const timeRecords = await this.timeRecordService.getTimeRecordsByUserIdProjectIdDate(userId, projectId, date, transaction);
    return timeRecords.length > 0;
  }

  async checkUserHasOpenTimeRecord(userId: number, date: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const openTimeRecord = await this.timeRecordService.getOpenTimeRecord(userId, date, transaction);
    if (!openTimeRecord) {
      return false; // No open time record found for the user on the specified date
    }
    return true;
  }

  async checkUserHasOpenOdometerReading(userId: number, date: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const openOdometerReading = await this.odometerReadingService.getOpenOdometerReading(userId, date, transaction);
    if (!openOdometerReading) {
      return false; // No open odometer reading found for the user on the specified date
    }
    return true;
  }

  async checkUserHasOdometerReadingsForDate(userId: number, date: DateTimeType, existingTransaction?: DbTransaction): Promise<boolean> {
    const transaction = await this.startTransactionIfNeeded(existingTransaction);

    const odometerReadings = await this.odometerReadingService.getOdometerReadingsByUserIdDate(userId, date, transaction);
    if (!odometerReadings || odometerReadings.length === 0) {
      return false; // No odometer readings found for the user on the specified date
    }
    return true;
  }

  // #endregion
  // #region Lookup

  // #endregion
  // #region Transform

  getClockStartActivityType(timeRecordActivity: TimeRecordActivity) {
    switch (timeRecordActivity) {
      case TimeRecordActivity.Working:
        return ActivityType.ClockIn;
      case TimeRecordActivity.Rest:
        return ActivityType.Rest;
      case TimeRecordActivity.Meal:
        return ActivityType.Meal;
    }
  }

  // #endregion
  // #region Other

  // #endregion
}
